export const allTranslations = {
  NEXT: {
    de: "Weiter",
    en: "Next",
    tr: "İleri",
    cs: "Další",
    ru: "Далее",
    hr: "Dalje",
    es: "Siguiente",
    fr: "Suivant",
    it: "Avanti",
    sq: "Tjetër",
  },
  AGREE: {
    de: "Verstanden",
    en: "Agree",
    tr: "Kabul Et",
    cs: "Souhlasím",
    ru: "Согласен",
    hr: "Slažem se",
    es: "De acuerdo",
    fr: "D'accord",
    it: "Accetto",
    sq: "Pajtohem",
  },
  SKIP: {
    de: "Überspringen",
    en: "Skip",
    tr: "Atla",
    cs: "Přeskočit",
    ru: "Пропустить",
    hr: "Preskoči",
    es: "Saltar",
    fr: "Passer",
    it: "Salta",
    sq: "Kalo",
  },
  BACK: {
    de: "Zurück",
    en: "Back",
    tr: "Geri",
    cs: "Zpět",
    ru: "Назад",
    hr: "Natrag",
    es: "Atrás",
    fr: "Retour",
    it: "Indietro",
    sq: "Prapa",
  },
  START: {
    de: "Starten",
    en: "Start",
    tr: "Başla",
    cs: "Start",
    ru: "Start",
    hr: "Start",
    es: "Empezar",
    fr: "Démarrer",
    it: "Inizia",
    sq: "Fillo",
  },
  DONE: {
    de: "Fertig",
    en: "Done",
    tr: "Tamamlandı",
    cs: "Hotovo",
    ru: "Готово",
    hr: "Gotovo",
    es: "Hecho",
    fr: "Terminé",
    it: "Fatto",
    sq: "U krye",
  },
  CONFIRM: {
    de: "Bestätigen",
    en: "Confirm",
    tr: "Onayla",
    cs: "Potvrdit",
    ru: "Подтвердить",
    hr: "Potvrdi",
    es: "Confirmar",
    fr: "Confirmer",
    it: "Conferma",
    sq: "Konfirmo",
  },
  UNDERSTOOD: {
    de: "Verstanden",
    en: "Understood",
    tr: "Anlaşıldı",
    cs: "Rozumím",
    ru: "Понятно",
    hr: "Razumijem",
    es: "Entendido",
    fr: "Compris",
    it: "Capito",
    sq: "E kuptova",
  },
  OPTIONAL: {
    de: "Optional",
    en: "Optional",
    tr: "Opsiyonel",
    cs: "Volitelné",
    ru: "Необязательно",
    hr: "Neobavezno",
    es: "Opcional",
    fr: "Optionnel",
    it: "Opzionale",
    sq: "Opsionale",
  },
  PLEASE_SELECT: {
    de: "Bitte auswählen",
    en: "Please select",
    tr: "Lütfen seçiniz",
    cs: "Prosím vyberte",
    ru: "Пожалуйста, выберите",
    hr: "Molimo odaberite",
    es: "Por favor seleccione",
    fr: "Veuillez sélectionner",
    it: "Seleziona",
    sq: "Ju lutem zgjidhni",
  },
  CONTRACT_VIEW_BUTTON: {
    de: "Vertrag anzeigen",
    en: "View contract",
    tr: "Sözleşmeyi görüntüle",
    cs: "Zobrazit smlouvu",
    ru: "Посмотреть договор",
    hr: "Pogledaj ugovor",
    es: "Ver contrato",
    fr: "Voir le contrat",
    it: "Vedi contratto",
    sq: "Shiko kontratën",
  },
  CONTRACT_SIGN_BUTTON: {
    de: "Zustimmen",
    en: "Agree",
    tr: "Kabul Et",
    cs: "Souhlasím",
    ru: "Согласен",
    hr: "Slažem se",
    es: "De acuerdo",
    fr: "D'accord",
    it: "Accetto",
    sq: "Pajtohem",
  },
  CONTRACT_CONTINUE: {
    de: "Weiter",
    en: "Continue",
    tr: "Devam et",
    cs: "Pokračovat",
    ru: "Продолжить",
    hr: "Nastavi",
    es: "Continuar",
    fr: "Continuer",
    it: "Continua",
    sq: "Vazhdo",
  },
  CONTRACT_PRE_HEADLINE: {
    de: "Unterschrift",
    en: "Signature",
    tr: "İmzalama",
    cs: "Podpis",
    ru: "Подпись",
    hr: "Potpis",
    es: "Firma",
    fr: "Signature",
    it: "Firma",
    sq: "Nënshkrimi",
  },
  CONTRACT_HEADLINE: {
    de: "Dokumentenübersicht",
    en: "Document overview",
    tr: "Belge genel bakışı",
    cs: "Přehled dokumentů",
    ru: "Обзор документов",
    hr: "Pregled dokumenata",
    es: "Resumen de documentos",
    fr: "Aperçu des documents",
    it: "Panoramica documenti",
    sq: "Përmbledhje e dokumenteve",
  },
  CONTRACT_DESCRIPTION: {
    de: "Fast geschafft! Bitte lies und unterschreibe unseren Behandlungsvertrag.",
    en: "Almost done! Please read and sign our treatment agreement.",
    tr: "Neredeyse bitti! Lütfen tedavi sözleşmemizi okuyun ve imzalayın.",
    cs: "Skoro hotovo! Přečtěte si a podepište naši smlouvu o ošetření.",
    ru: "Почти готово! Пожалуйста, прочитайте и подпишите наш договор на лечение.",
    hr: "Skoro gotovo! Molimo pročitajte i potpišite naš ugovor o liječenju.",
    es: "¡Casi listo! Por favor lee y firma nuestro acuerdo de tratamiento.",
    fr: "Presque fini ! Veuillez lire et signer notre contrat de traitement.",
    it: "Quasi fatto! Leggi e firma il nostro contratto di trattamento.",
    sq: "Gati përfundoi! Ju lutem lexoni dhe nënshkruani marrëveshjen tonë të trajtimit.",
  },
  CONTRACT_PENDING_MESSAGE: {
    de: "Bitte Vertrag anzeigen und unterschreiben.",
    en: "Please view and sign the contract.",
    tr: "Lütfen sözleşmeyi görüntüleyip imzalayın.",
    cs: "Zobrazte a podepište smlouvu.",
    ru: "Пожалуйста, просмотрите и подпишите договор.",
    hr: "Molimo pogledajte i potpišite ugovor.",
    es: "Por favor vea y firme el contrato.",
    fr: "Veuillez voir et signer le contrat.",
    it: "Vedi e firma il contratto.",
    sq: "Ju lutem shikoni dhe nënshkruani kontratën.",
  },
  CONTRACT_COMPLETED_MESSAGE: {
    de: "Vertrag erfolgreich unterschrieben.",
    en: "Contract successfully signed.",
    tr: "Sözleşme başarıyla imzalandı.",
    cs: "Smlouva úspěšně podepsána.",
    ru: "Договор успешно подписан.",
    hr: "Ugovor uspješno potpisan.",
    es: "Contrato firmado con éxito.",
    fr: "Contrat signé avec succès.",
    it: "Contratto firmato con successo.",
    sq: "Kontrata u nënshkrua me sukses.",
  },
  WELCOME_TITLE: {
    de: "Willkommen zu",
    en: "Welcome to",
    tr: "Hoş geldiniz",
    cs: "Vítejte v",
    ru: "Добро пожаловать в",
    hr: "Dobrodošli u",
    es: "Bienvenido a",
    fr: "Bienvenue à",
    it: "Benvenuti a",
    sq: "Mirësevini në",
  },
  WELCOME_FIRST_TIME: {
    de: "Ich bin das erste Mal hier",
    en: "This is my first time here",
    tr: "İlk kez buradayım",
    cs: "Jsem tu poprvé",
    ru: "Я здесь впервые",
    hr: "Prvi put sam ovdje",
    es: "Es mi primera vez aquí",
    fr: "C'est ma première fois ici",
    it: "È la mia prima volta qui",
    sq: "Është hera ime e parë këtu",
  },
  WELCOME_FIRST_TIME_SUBTITLE: {
    de: "Daten jetzt erfassen",
    en: "Fill out information now",
    tr: "Şimdi bilgileri doldurun",
    cs: "Vyplnit údaje nyní",
    ru: "Заполнить данные сейчас",
    hr: "Ispunite podatke sada",
    es: "Rellenar información ahora",
    fr: "Remplir les informations maintenant",
    it: "Compila le informazioni ora",
    sq: "Plotësoni informacionin tani",
  },
  WELCOME_RETURNING: {
    de: "Ich war schon einmal hier",
    en: "I have been here before",
    tr: "Daha önce burada bulundum",
    cs: "Už jsem tu byl(a)",
    ru: "Я уже был здесь",
    hr: "Već sam bio/bila ovdje",
    es: "Ya he estado aquí antes",
    fr: "Je suis déjà venu ici",
    it: "Sono già stato qui",
    sq: "Kam qenë këtu më parë",
  },
  WELCOME_RETURNING_SUBTITLE: {
    de: "Jetzt anmelden",
    en: "Check in now",
    tr: "Şimdi giriş yap",
    cs: "Přihlásit se",
    ru: "Зарегистрироваться сейчас",
    hr: "Prijavite se sada",
    es: "Registrarse ahora",
    fr: "S'enregistrer maintenant",
    it: "Check-in ora",
    sq: "Regjistrohuni tani",
  },
  ONBOARDING_HEADLINE: {
    de: "Willkommen in unserer Praxis",
    en: "Welcome to our practice",
    tr: "Kliniğimize hoş geldiniz",
    cs: "Vítejte v naší praxi",
    ru: "Добро пожаловать в нашу клинику",
    hr: "Dobrodošli u našu ordinaciju",
    es: "Bienvenido a nuestra clínica",
    fr: "Bienvenue dans notre cabinet",
    it: "Benvenuti nel nostro studio",
    sq: "Mirësevini në klinikën tonë",
  },
  ONBOARDING_DESCRIPTION: {
    de: "Um die Patientenaufnahme und Anamnese für Sie so einfach wie möglich zu gestalten findet diese digital statt. Bitte füllen Sie auf den folgenden Seiten alle Informationen aus.",
    en: "To make patient intake and anamnesis as easy as possible for you, this is done digitally. Please fill out all information on the following pages.",
    tr: "Hasta kabulü ve anamnez işlemlerini sizin için mümkün olduğunca kolaylaştırmak amacıyla bu işlemler dijital olarak yapılmaktadır. Lütfen aşağıdaki sayfalarda tüm bilgileri doldurun.",
    cs: "Abychom vám co nejvíce usnadnili příjem pacienta a anamnézu, provádí se to digitálně. Vyplňte prosím všechny informace na následujících stránkách.",
    ru: "Чтобы сделать прием пациента и сбор анамнеза максимально простым для вас, это делается в цифровом виде. Пожалуйста, заполните всю информацию на следующих страницах.",
    hr: "Kako bismo vam prijem pacijenata i anamnezu učinili što jednostavnijim, to se radi digitalno. Molimo ispunite sve podatke na sljedećim stranicama.",
    es: "Para facilitar al máximo el ingreso del paciente y la anamnesis, esto se realiza digitalmente. Por favor, complete toda la información en las siguientes páginas.",
    fr: "Pour rendre l'admission des patients et l'anamnèse aussi simples que possible pour vous, cela se fait numériquement. Veuillez remplir toutes les informations sur les pages suivantes.",
    it: "Per rendere l'accettazione del paziente e l'anamnesi il più semplice possibile, tutto avviene digitalmente. Compila tutte le informazioni nelle pagine seguenti.",
    sq: "Për ta bërë pranimin e pacientit dhe anamnezën sa më të lehtë për ju, kjo bëhet në mënyrë dixhitale. Ju lutem plotësoni të gjitha informacionet në faqet në vijim.",
  },
  LOGIN_HEADLINE: {
    de: "Anmeldung",
    en: "Login",
    tr: "Giriş",
    cs: "Přihlášení",
    ru: "Вход",
    hr: "Prijava",
    es: "Iniciar sesión",
    fr: "Connexion",
    it: "Accesso",
    sq: "Identifikimi",
  },
  LOGIN_DESCRIPTION: {
    de: "Bitte geben Sie Ihre Handynummer ein. Wir schicken Ihnen einen Bestätigungscode per SMS.",
    en: "Please enter your mobile number. We will send you a confirmation code via SMS.",
    tr: "Lütfen cep telefonu numaranızı girin. Size SMS ile bir doğrulama kodu göndereceğiz.",
    cs: "Zadejte prosím své mobilní číslo. Pošleme vám potvrzovací kód přes SMS.",
    ru: "Пожалуйста, введите ваш номер мобильного телефона. Мы отправим вам код подтверждения по SMS.",
    hr: "Molimo unesite broj mobitela. Poslat ćemo vam potvrdni kod SMS-om.",
    es: "Por favor, introduzca su número de móvil. Le enviaremos un código de confirmación por SMS.",
    fr: "Veuillez entrer votre numéro de mobile. Nous vous enverrons un code de confirmation par SMS.",
    it: "Inserisci il tuo numero di cellulare. Ti invieremo un codice di conferma via SMS.",
    sq: "Ju lutem shkruani numrin tuaj celular. Do t'ju dërgojmë një kod konfirmimi me SMS.",
  },
  SMS_LOGIN_NUMBER_LABEL: {
    de: "Handynummer",
    en: "Mobile number",
    tr: "Cep telefonu numarası",
    cs: "Mobilní číslo",
    ru: "Номер мобильного",
    hr: "Broj mobitela",
    es: "Número de móvil",
    fr: "Numéro de mobile",
    it: "Numero di cellulare",
    sq: "Numri celular",
  },
  SMS_LOGIN_NO_PHONE_HINT: {
    de: "Kein Handy oder keine SMS erhalten? Am Empfang bekommen Sie einen Anmeldecode.",
    en: "No mobile phone or no SMS? You can get a sign-in code at the reception.",
    tr: "Cep telefonunuz yok mu veya SMS almadınız mı? Resepsiyondan bir giriş kodu alabilirsiniz.",
    cs: "Nemáte mobilní telefon nebo jste nedostali SMS? Přihlašovací kód dostanete na recepci.",
    ru: "Нет мобильного телефона или не получили SMS? Код для входа можно получить на рецепции.",
    hr: "Nemate mobitel ili niste primili SMS? Kod za prijavu dobit ćete na recepciji.",
    es: "¿No tiene teléfono móvil o no ha recibido el SMS? Recibirá un código de acceso en la recepción.",
    fr: "Pas de téléphone mobile ou aucun SMS reçu ? Vous recevrez un code de connexion à la réception.",
    it: "Non hai un cellulare o non hai ricevuto l'SMS? Riceverai un codice di accesso alla reception.",
    sq: "Nuk keni telefon celular ose nuk keni marrë SMS? Do të merrni një kod identifikimi në recepsion.",
  },
  SMS_LOGIN_SEND_CODE: {
    de: "SMS-Code senden",
    en: "Send SMS code",
    tr: "SMS kodunu gönder",
    cs: "Odeslat SMS kód",
    ru: "Отправить SMS-код",
    hr: "Pošalji SMS kod",
    es: "Enviar código SMS",
    fr: "Envoyer le code SMS",
    it: "Invia codice SMS",
    sq: "Dërgo kodin SMS",
  },
  SMS_LOGIN_CODE_HEADLINE: {
    de: "SMS-Code eingeben",
    en: "Enter SMS code",
    tr: "SMS kodunu girin",
    cs: "Zadejte SMS kód",
    ru: "Введите SMS-код",
    hr: "Unesite SMS kod",
    es: "Ingrese el código SMS",
    fr: "Entrez le code SMS",
    it: "Inserisci il codice SMS",
    sq: "Shkruani kodin SMS",
  },
  SMS_LOGIN_CODE_DESCRIPTION: {
    de: "Wir haben einen 6-stelligen Code an {{phoneNumber}} gesendet.",
    en: "We sent a 6-digit code to {{phoneNumber}}.",
    tr: "Size {{phoneNumber}} numarasına 6 haneli bir kod gönderdik.",
    cs: "Poslali jsme 6místný kód na {{phoneNumber}}.",
    ru: "Мы отправили 6-значный код на номер {{phoneNumber}}.",
    hr: "Poslali smo 6-znamenkasti kod na {{phoneNumber}}.",
    es: "Le hemos enviado un código de 6 dígitos al {{phoneNumber}}.",
    fr: "Nous avons envoyé un code à 6 chiffres au {{phoneNumber}}.",
    it: "Ti abbiamo inviato un codice a 6 cifre al {{phoneNumber}}.",
    sq: "Ju kemi dërguar një kod 6-shifror në {{phoneNumber}}.",
  },
  SMS_LOGIN_CODE_DESCRIPTION_SUPPORT: {
    de: "Bitte geben Sie den 6-stelligen Code ein, den Sie für diese Nummer erhalten haben.",
    en: "Please enter the 6-digit code you received for this number.",
    tr: "Lütfen bu numara için aldığınız 6 haneli kodu girin.",
    cs: "Zadejte prosím 6místný kód, který jste obdrželi pro toto číslo.",
    ru: "Пожалуйста, введите 6-значный код, который вы получили для этого номера.",
    hr: "Unesite 6-znamenkasti kod koji ste dobili za ovaj broj.",
    es: "Introduzca el código de 6 dígitos que ha recibido para este número.",
    fr: "Veuillez entrer le code à 6 chiffres que vous avez reçu pour ce numéro.",
    it: "Inserisci il codice a 6 cifre che hai ricevuto per questo numero.",
    sq: "Ju lutem shkruani kodin 6-shifror që keni marrë për këtë numër.",
  },
  SMS_LOGIN_CHANGE_NUMBER: {
    de: "Nummer ändern",
    en: "Change number",
    tr: "Numarayı değiştir",
    cs: "Změnit číslo",
    ru: "Изменить номер",
    hr: "Promijeni broj",
    es: "Cambiar número",
    fr: "Changer de numéro",
    it: "Cambia numero",
    sq: "Ndrysho numrin",
  },
  SMS_LOGIN_RESEND: {
    de: "SMS erneut senden",
    en: "Resend SMS",
    tr: "SMS'i yeniden gönder",
    cs: "Znovu odeslat SMS",
    ru: "Отправить SMS снова",
    hr: "Pošalji SMS ponovo",
    es: "Reenviar SMS",
    fr: "Renvoyer le SMS",
    it: "Reinvia SMS",
    sq: "Ri-dërgo SMS-në",
  },
  SMS_LOGIN_RESEND_IN: {
    de: "SMS erneut senden ({{time}})",
    en: "Resend SMS ({{time}})",
    tr: "SMS'i yeniden gönder ({{time}})",
    cs: "Znovu odeslat SMS ({{time}})",
    ru: "Отправить SMS снова ({{time}})",
    hr: "Pošalji SMS ponovo ({{time}})",
    es: "Reenviar SMS ({{time}})",
    fr: "Renvoyer le SMS ({{time}})",
    it: "Reinvia SMS ({{time}})",
    sq: "Ri-dërgo SMS-në ({{time}})",
  },
  SMS_LOGIN_NO_SMS_HINT: {
    de: "Keine SMS erhalten? Am Empfang bekommen Sie alternativ einen Anmeldecode.",
    en: "No SMS? Alternatively, you can get a sign-in code at the reception.",
    tr: "SMS almadınız mı? Alternatif olarak resepsiyondan bir giriş kodu alabilirsiniz.",
    cs: "Nedostali jste SMS? Alternativně dostanete přihlašovací kód na recepci.",
    ru: "Не получили SMS? Код для входа можно также получить на рецепции.",
    hr: "Niste primili SMS? Kod za prijavu možete dobiti i na recepciji.",
    es: "¿No ha recibido el SMS? Como alternativa, puede recibir un código de acceso en la recepción.",
    fr: "Vous n'avez pas reçu de SMS ? Vous pouvez aussi obtenir un code de connexion à la réception.",
    it: "Non hai ricevuto l'SMS? In alternativa, puoi ricevere un codice di accesso alla reception.",
    sq: "Nuk keni marrë SMS? Si alternativë, mund të merrni një kod identifikimi në recepsion.",
  },
  SMS_LOGIN_CHOOSER_HEADLINE: {
    de: "Für wen füllen Sie das Formular aus?",
    en: "Who are you filling in the form for?",
    tr: "Formu kimin için dolduruyorsunuz?",
    cs: "Za koho formulář vyplňujete?",
    ru: "Для кого вы заполняете форму?",
    hr: "Za koga popunjavate obrazac?",
    es: "¿Para quién está rellenando el formulario?",
    fr: "Pour qui remplissez-vous le formulaire ?",
    it: "Per chi stai compilando il modulo?",
    sq: "Për kë po e plotësoni formularin?",
  },
  SMS_LOGIN_CHOOSER_DESCRIPTION: {
    de: "Sie können das Formular für sich selbst oder für eine andere Person ausfüllen. Ist die Person noch nicht aufgeführt, wählen Sie „Andere Person“.",
    en: "You can fill in the form for yourself or for another person. If the person is not listed yet, choose “Other person”.",
    tr: "Formu kendiniz veya başka bir kişi için doldurabilirsiniz. Kişi henüz listelenmemişse „Başka bir kişi“ seçeneğini seçin.",
    cs: "Formulář můžete vyplnit za sebe nebo za jinou osobu. Pokud osoba ještě není uvedena, zvolte „Jiná osoba“.",
    ru: "Вы можете заполнить форму для себя или для другого человека. Если этого человека ещё нет в списке, выберите «Другой человек».",
    hr: "Obrazac možete popuniti za sebe ili za drugu osobu. Ako osoba još nije navedena, odaberite „Druga osoba”.",
    es: "Puede rellenar el formulario para usted o para otra persona. Si la persona aún no aparece, elija «Otra persona».",
    fr: "Vous pouvez remplir le formulaire pour vous-même ou pour une autre personne. Si la personne ne figure pas encore ici, choisissez « Autre personne ».",
    it: "Puoi compilare il modulo per te o per un'altra persona. Se la persona non è ancora elencata, scegli «Altra persona».",
    sq: "Mund ta plotësoni formularin për veten tuaj ose për një person tjetër. Nëse personi nuk është ende i listuar, zgjidhni „Person tjetër“.",
  },
  SMS_LOGIN_CHOOSER_BORN: {
    de: "geboren am {{date}}",
    en: "born on {{date}}",
    tr: "doğum tarihi {{date}}",
    cs: "datum narození: {{date}}",
    ru: "дата рождения {{date}}",
    hr: "datum rođenja: {{date}}",
    es: "fecha de nacimiento: {{date}}",
    fr: "date de naissance : {{date}}",
    it: "data di nascita: {{date}}",
    sq: "lindur më {{date}}",
  },
  SMS_LOGIN_CHOOSER_UNNAMED: {
    de: "Eintrag ohne Namen",
    en: "Entry without a name",
    tr: "İsimsiz kayıt",
    cs: "Záznam bez jména",
    ru: "Запись без имени",
    hr: "Zapis bez imena",
    es: "Entrada sin nombre",
    fr: "Entrée sans nom",
    it: "Voce senza nome",
    sq: "Regjistrim pa emër",
  },
  SMS_LOGIN_CHOOSER_LAST_ACTIVE: {
    de: "zuletzt aktiv am {{date}}",
    en: "last active on {{date}}",
    tr: "son aktiflik: {{date}}",
    cs: "naposledy aktivní {{date}}",
    ru: "последняя активность {{date}}",
    hr: "zadnja aktivnost {{date}}",
    es: "última actividad el {{date}}",
    fr: "dernière activité le {{date}}",
    it: "ultima attività il {{date}}",
    sq: "aktiv për herë të fundit më {{date}}",
  },
  SMS_LOGIN_CHOOSER_DESCRIPTION_ONE: {
    de: "Sie können das Formular für sich selbst oder für eine andere Person ausfüllen. Ist die Person noch nicht aufgeführt, wählen Sie „Andere Person“.",
    en: "You can fill in the form for yourself or for another person. If the person is not listed yet, choose “Other person”.",
    tr: "Formu kendiniz veya başka bir kişi için doldurabilirsiniz. Kişi henüz listelenmemişse „Başka bir kişi“ seçeneğini seçin.",
    cs: "Formulář můžete vyplnit za sebe nebo za jinou osobu. Pokud osoba ještě není uvedena, zvolte „Jiná osoba“.",
    ru: "Вы можете заполнить форму для себя или для другого человека. Если этого человека ещё нет в списке, выберите «Другой человек».",
    hr: "Obrazac možete popuniti za sebe ili za drugu osobu. Ako osoba još nije navedena, odaberite „Druga osoba”.",
    es: "Puede rellenar el formulario para usted o para otra persona. Si la persona aún no aparece, elija «Otra persona».",
    fr: "Vous pouvez remplir le formulaire pour vous-même ou pour une autre personne. Si la personne ne figure pas encore ici, choisissez « Autre personne ».",
    it: "Puoi compilare il modulo per te o per un'altra persona. Se la persona non è ancora elencata, scegli «Altra persona».",
    sq: "Mund ta plotësoni formularin për veten tuaj ose për një person tjetër. Nëse personi nuk është ende i listuar, zgjidhni „Person tjetër“.",
  },
  SMS_LOGIN_CHOOSER_OTHER: {
    de: "Andere Person",
    en: "Other person",
    tr: "Başka bir kişi",
    cs: "Jiná osoba",
    ru: "Другой человек",
    hr: "Druga osoba",
    es: "Otra persona",
    fr: "Autre personne",
    it: "Altra persona",
    sq: "Person tjetër",
  },
  SMS_LOGIN_CHOOSER_OTHER_SUBTITLE: {
    de: "z.B. Familienmitglied, Partner",
    en: "e.g. family member, partner",
    tr: "örn. aile üyesi, partner",
    cs: "např. člen rodiny, partner",
    ru: "например, член семьи, партнёр",
    hr: "npr. član obitelji, partner",
    es: "p. ej., familiar, pareja",
    fr: "p. ex. membre de la famille, partenaire",
    it: "ad es. familiare, partner",
    sq: "p.sh. anëtar i familjes, partner",
  },
  SMS_LOGIN_CHOOSER_LEAVE_TITLE: {
    de: "Abmelden?",
    en: "Sign out?",
    tr: "Oturum kapatılsın mı?",
    cs: "Odhlásit se?",
    ru: "Выйти?",
    hr: "Odjaviti se?",
    es: "¿Cerrar sesión?",
    fr: "Se déconnecter ?",
    it: "Uscire?",
    sq: "Të dilni?",
  },
  SMS_LOGIN_CHOOSER_LEAVE_CANCEL: {
    de: "Hierbleiben",
    en: "Stay here",
    tr: "Burada kalın",
    cs: "Zůstat zde",
    ru: "Остаться",
    hr: "Ostanite ovdje",
    es: "Quedarse aquí",
    fr: "Rester ici",
    it: "Resta qui",
    sq: "Qëndroni këtu",
  },
  SMS_LOGIN_OTHER_PERSON_TEXT: {
    de: "Bitte geben Sie Vorname, Nachname und Geburtsdatum der Person an, für die Sie das Formular ausfüllen.",
    en: "Please enter the first name, last name and date of birth of the person you are filling in the form for.",
    tr: "Lütfen formu doldurduğunuz kişinin adını, soyadını ve doğum tarihini girin.",
    cs: "Zadejte prosím jméno, příjmení a datum narození osoby, za kterou formulář vyplňujete.",
    ru: "Пожалуйста, укажите имя, фамилию и дату рождения человека, для которого вы заполняете форму.",
    hr: "Unesite ime, prezime i datum rođenja osobe za koju popunjavate obrazac.",
    es: "Indique el nombre, los apellidos y la fecha de nacimiento de la persona para la que está rellenando el formulario.",
    fr: "Veuillez indiquer le prénom, le nom et la date de naissance de la personne pour laquelle vous remplissez le formulaire.",
    it: "Inserisci nome, cognome e data di nascita della persona per cui stai compilando il modulo.",
    sq: "Ju lutem shkruani emrin, mbiemrin dhe datëlindjen e personit për të cilin po e plotësoni formularin.",
  },
  SMS_LOGIN_ERROR_TOO_MANY_PERSONS: {
    de: "Unter Ihrer Handynummer sind in dieser Praxis bereits viele Personen gespeichert. Bitte wenden Sie sich an die Praxis.",
    en: "Many people are already saved with your mobile number at this practice. Please contact the practice.",
    tr: "Bu klinikte cep telefonu numaranızla zaten çok sayıda kişi kayıtlı. Lütfen klinikle iletişime geçin.",
    cs: "Pod vaším mobilním číslem je v této praxi uloženo již mnoho osob. Obraťte se prosím na praxi.",
    ru: "На ваш номер мобильного телефона в этой клинике уже записано много людей. Пожалуйста, обратитесь в клинику.",
    hr: "Pod vašim brojem mobitela u ovoj je ordinaciji već spremljeno mnogo osoba. Obratite se ordinaciji.",
    es: "Ya hay muchas personas guardadas con su número de móvil en esta clínica. Póngase en contacto con la clínica.",
    fr: "De nombreuses personnes sont déjà enregistrées avec votre numéro de mobile dans ce cabinet. Veuillez contacter le cabinet.",
    it: "Con il tuo numero di cellulare sono già salvate molte persone in questo studio. Rivolgiti allo studio.",
    sq: "Nën numrin tuaj celular janë ruajtur tashmë shumë persona në këtë klinikë. Ju lutem kontaktoni klinikën.",
  },
  SMS_LOGIN_ERROR_INVALID_PERSON: {
    de: "Bitte prüfen Sie Vorname, Nachname und Geburtsdatum.",
    en: "Please check the first name, last name and date of birth.",
    tr: "Lütfen adı, soyadı ve doğum tarihini kontrol edin.",
    cs: "Zkontrolujte prosím jméno, příjmení a datum narození.",
    ru: "Пожалуйста, проверьте имя, фамилию и дату рождения.",
    hr: "Provjerite ime, prezime i datum rođenja.",
    es: "Compruebe el nombre, los apellidos y la fecha de nacimiento.",
    fr: "Veuillez vérifier le prénom, le nom et la date de naissance.",
    it: "Controlla nome, cognome e data di nascita.",
    sq: "Ju lutem kontrolloni emrin, mbiemrin dhe datëlindjen.",
  },
  PERSONAL_INFO_OTHER_PERSON_TITLE: {
    de: "Eine andere Person?",
    en: "Another person?",
    tr: "Başka bir kişi mi?",
    cs: "Jiná osoba?",
    ru: "Другой человек?",
    hr: "Druga osoba?",
    es: "¿Otra persona?",
    fr: "Une autre personne ?",
    it: "Un'altra persona?",
    sq: "Një person tjetër?",
  },
  PERSONAL_INFO_OTHER_PERSON_TEXT: {
    de: "Gespeichert ist: {{person}}. Füllen Sie das Formular für eine andere Person aus?",
    en: "Saved here: {{person}}. Are you filling in the form for someone else?",
    tr: "Burada kayıtlı: {{person}}. Formu başka bir kişi için mi dolduruyorsunuz?",
    cs: "Zde jsou uloženy údaje osoby {{person}}. Vyplňujete formulář za jinou osobu?",
    ru: "Здесь сохранены данные: {{person}}. Вы заполняете форму для другого человека?",
    hr: "Ovdje su spremljeni podaci osobe {{person}}. Popunjavate li obrazac za drugu osobu?",
    es: "Aquí están guardados los datos de {{person}}. ¿Está rellenando el formulario para otra persona?",
    fr: "Les données enregistrées ici sont celles de {{person}}. Remplissez-vous le formulaire pour une autre personne ?",
    it: "Qui sono salvati i dati di {{person}}. Stai compilando il modulo per un'altra persona?",
    sq: "Këtu janë ruajtur të dhënat e {{person}}. A po e plotësoni formularin për një person tjetër?",
  },
  PERSONAL_INFO_OTHER_PERSON_YES: {
    de: "Ja, andere Person",
    en: "Yes, someone else",
    tr: "Evet, başka bir kişi",
    cs: "Ano, jiná osoba",
    ru: "Да, другой человек",
    hr: "Da, druga osoba",
    es: "Sí, otra persona",
    fr: "Oui, une autre personne",
    it: "Sì, un'altra persona",
    sq: "Po, person tjetër",
  },
  PERSONAL_INFO_OTHER_PERSON_NO: {
    de: "Nein, Angaben korrigieren",
    en: "No, correct the details",
    tr: "Hayır, bilgileri düzelt",
    cs: "Ne, opravit údaje",
    ru: "Нет, исправить данные",
    hr: "Ne, ispravi podatke",
    es: "No, corregir los datos",
    fr: "Non, corriger les données",
    it: "No, correggi i dati",
    sq: "Jo, korrigjo të dhënat",
  },
  PERSONAL_INFO_OTHER_PERSON_SIGN_IN_AGAIN: {
    de: "Für eine andere Person melden Sie sich bitte neu an.",
    en: "Please sign in again for the other person.",
    tr: "Başka bir kişi için lütfen yeniden giriş yapın.",
    cs: "Pro jinou osobu se prosím přihlaste znovu.",
    ru: "Для другого человека, пожалуйста, войдите заново.",
    hr: "Za drugu osobu prijavite se ponovno.",
    es: "Para otra persona, vuelva a iniciar sesión.",
    fr: "Pour une autre personne, veuillez vous reconnecter.",
    it: "Per un'altra persona, accedi di nuovo.",
    sq: "Për një person tjetër, ju lutem hyni përsëri.",
  },
  FORM_LEAVE_TITLE: {
    de: "Formular verlassen?",
    en: "Leave the form?",
    tr: "Formdan çıkılsın mı?",
    cs: "Opustit formulář?",
    ru: "Покинуть форму?",
    hr: "Napustiti obrazac?",
    es: "¿Salir del formulario?",
    fr: "Quitter le formulaire ?",
    it: "Uscire dal modulo?",
    sq: "Të dilni nga formulari?",
  },
  FORM_LEAVE_TEXT: {
    de: "Wenn Sie zurückgehen, werden Sie abgemeldet. Zum Weitermachen melden Sie sich dann mit einem neuen Code an.",
    en: "If you go back, you will be signed out. To continue, you then sign in again with a new code.",
    tr: "Geri giderseniz oturumunuz kapatılır. Devam etmek için yeni bir kodla tekrar giriş yapın.",
    cs: "Pokud se vrátíte, budete odhlášeni. Pro pokračování se znovu přihlaste pomocí nového kódu.",
    ru: "Если вы вернётесь назад, вы выйдете из системы. Чтобы продолжить, войдите снова с новым кодом.",
    hr: "Ako se vratite, bit ćete odjavljeni. Za nastavak se ponovno prijavite novim kodom.",
    es: "Si vuelve atrás, se cerrará su sesión. Para continuar, inicie sesión de nuevo con un código nuevo.",
    fr: "Si vous revenez en arrière, vous serez déconnecté. Pour continuer, reconnectez-vous avec un nouveau code.",
    it: "Se torni indietro, verrai disconnesso. Per continuare, accedi di nuovo con un nuovo codice.",
    sq: "Nëse ktheheni prapa, do të dilni nga llogaria. Për të vazhduar, identifikohuni përsëri me një kod të ri.",
  },
  FORM_LEAVE_CONFIRM: {
    de: "Abmelden",
    en: "Sign out",
    tr: "Oturumu kapat",
    cs: "Odhlásit se",
    ru: "Выйти",
    hr: "Odjavi se",
    es: "Cerrar sesión",
    fr: "Se déconnecter",
    it: "Esci",
    sq: "Dilni",
  },
  FORM_LEAVE_CANCEL: {
    de: "Weiter ausfüllen",
    en: "Keep filling in",
    tr: "Doldurmaya devam et",
    cs: "Pokračovat ve vyplňování",
    ru: "Продолжить заполнение",
    hr: "Nastavi ispunjavati",
    es: "Seguir rellenando",
    fr: "Continuer à remplir",
    it: "Continua a compilare",
    sq: "Vazhdoni plotësimin",
  },
  SMS_LOGIN_SESSION_EXPIRED: {
    de: "Ihre Anmeldung ist abgelaufen. Bitte melden Sie sich erneut an.",
    en: "Your sign-in has expired. Please sign in again.",
    tr: "Oturumunuzun süresi doldu. Lütfen tekrar giriş yapın.",
    cs: "Vaše přihlášení vypršelo. Přihlaste se prosím znovu.",
    ru: "Срок вашего входа истёк. Пожалуйста, войдите снова.",
    hr: "Vaša prijava je istekla. Prijavite se ponovno.",
    es: "Su sesión ha caducado. Por favor, inicie sesión de nuevo.",
    fr: "Votre connexion a expiré. Veuillez vous reconnecter.",
    it: "La tua sessione è scaduta. Accedi di nuovo.",
    sq: "Identifikimi juaj ka skaduar. Ju lutem identifikohuni përsëri.",
  },
  SMS_LOGIN_ERROR_NUMBER_INVALID: {
    de: "Diese Handynummer ist ungültig. Bitte prüfen Sie Ihre Eingabe.",
    en: "This mobile number is invalid. Please check your entry.",
    tr: "Bu cep telefonu numarası geçersiz. Lütfen girişinizi kontrol edin.",
    cs: "Toto mobilní číslo je neplatné. Zkontrolujte prosím zadané údaje.",
    ru: "Этот номер мобильного телефона недействителен. Пожалуйста, проверьте введённые данные.",
    hr: "Ovaj broj mobitela nije valjan. Provjerite unesene podatke.",
    es: "Este número de móvil no es válido. Compruebe su entrada.",
    fr: "Ce numéro de mobile n'est pas valide. Veuillez vérifier votre saisie.",
    it: "Questo numero di cellulare non è valido. Controlla i dati inseriti.",
    sq: "Ky numër celular është i pavlefshëm. Ju lutem kontrolloni të dhënat e futura.",
  },
  SMS_LOGIN_ERROR_NOT_MOBILE: {
    de: "Das ist keine Handynummer. Der Code kommt per SMS, bitte geben Sie eine Handynummer ein. Ohne Handy bekommen Sie am Empfang Ihrer Praxis einen Code.",
    en: "This is not a mobile number. The code is sent by SMS, so please enter a mobile number. Without a mobile phone, you can get a code at the reception of your practice.",
    tr: "Bu bir cep telefonu numarası değil. Kod SMS ile gönderildiği için lütfen bir cep telefonu numarası girin. Cep telefonunuz yoksa kliniğinizin resepsiyonundan bir kod alabilirsiniz.",
    cs: "Toto není mobilní číslo. Kód se posílá SMS zprávou, zadejte prosím mobilní číslo. Pokud nemáte mobilní telefon, dostanete kód na recepci své praxe.",
    ru: "Это не номер мобильного телефона. Код отправляется по SMS, поэтому введите, пожалуйста, номер мобильного телефона. Если у вас нет мобильного телефона, вы получите код на рецепции вашей клиники.",
    hr: "Ovo nije broj mobitela. Kod se šalje SMS-om, unesite broj mobitela. Ako nemate mobitel, kod ćete dobiti na recepciji svoje ordinacije.",
    es: "Este no es un número de móvil. El código se envía por SMS, así que introduzca un número de móvil. Si no tiene móvil, recibirá un código en la recepción de su clínica.",
    fr: "Ce n'est pas un numéro de mobile. Le code est envoyé par SMS, veuillez donc entrer un numéro de mobile. Sans téléphone mobile, vous recevrez un code à la réception de votre cabinet.",
    it: "Questo non è un numero di cellulare. Il codice viene inviato via SMS, inserisci un numero di cellulare. Senza cellulare, riceverai un codice alla reception del tuo studio.",
    sq: "Ky nuk është numër celular. Kodi dërgohet me SMS, ju lutem shkruani një numër celular. Pa telefon celular, do të merrni një kod në recepsionin e klinikës suaj.",
  },
  SMS_LOGIN_ERROR_TOO_MANY_REQUESTS: {
    de: "Zu viele Versuche. Bitte warten Sie eine Weile und versuchen Sie es dann erneut. Wenn es eilt, bekommen Sie am Empfang Ihrer Praxis einen Code.",
    en: "Too many attempts. Please wait a while and try again. If it is urgent, you can get a code at the reception of your practice.",
    tr: "Çok fazla deneme yapıldı. Lütfen bir süre bekleyip tekrar deneyin. Aciliyse kliniğinizin resepsiyonundan bir kod alabilirsiniz.",
    cs: "Příliš mnoho pokusů. Počkejte prosím chvíli a zkuste to znovu. Pokud to spěchá, dostanete kód na recepci své praxe.",
    ru: "Слишком много попыток. Пожалуйста, подождите немного и попробуйте снова. Если это срочно, вы получите код на рецепции вашей клиники.",
    hr: "Previše pokušaja. Pričekajte malo i pokušajte ponovo. Ako je hitno, kod ćete dobiti na recepciji svoje ordinacije.",
    es: "Demasiados intentos. Espere un momento y vuelva a intentarlo. Si es urgente, recibirá un código en la recepción de su clínica.",
    fr: "Trop de tentatives. Veuillez patienter un moment puis réessayer. En cas d'urgence, vous recevrez un code à la réception de votre cabinet.",
    it: "Troppi tentativi. Attendi un momento e riprova. Se è urgente, riceverai un codice alla reception del tuo studio.",
    sq: "Shumë përpjekje. Ju lutem prisni pak dhe provoni përsëri. Nëse është urgjente, do të merrni një kod në recepsionin e klinikës suaj.",
  },
  SMS_LOGIN_ERROR_UNAVAILABLE: {
    de: "Die Anmeldung per SMS ist gerade nicht möglich. Bitte versuchen Sie es später erneut oder wenden Sie sich an Ihre Praxis.",
    en: "Signing in by SMS is not possible right now. Please try again later or contact your practice.",
    tr: "SMS ile giriş şu anda mümkün değil. Lütfen daha sonra tekrar deneyin veya kliniğinizle iletişime geçin.",
    cs: "Přihlášení pomocí SMS momentálně není možné. Zkuste to prosím později znovu nebo kontaktujte svou praxi.",
    ru: "Вход по SMS сейчас невозможен. Пожалуйста, попробуйте позже или свяжитесь с вашей клиникой.",
    hr: "Prijava putem SMS-a trenutno nije moguća. Pokušajte kasnije ili kontaktirajte svoju ordinaciju.",
    es: "El inicio de sesión por SMS no es posible en este momento. Inténtelo de nuevo más tarde o póngase en contacto con su clínica.",
    fr: "La connexion par SMS n'est pas possible pour le moment. Veuillez réessayer plus tard ou contacter votre cabinet.",
    it: "L'accesso via SMS non è possibile in questo momento. Riprova più tardi o contatta il tuo studio.",
    sq: "Identifikimi me SMS nuk është i mundur tani. Ju lutem provoni më vonë ose kontaktoni klinikën tuaj.",
  },
  SMS_LOGIN_ERROR_REGION: {
    de: "An Nummern aus diesem Land können wir leider keine SMS senden. Bitte wenden Sie sich an Ihre Praxis.",
    en: "We cannot send SMS to numbers from this country. Please contact your practice.",
    tr: "Bu ülkedeki numaralara maalesef SMS gönderemiyoruz. Lütfen kliniğinizle iletişime geçin.",
    cs: "Na čísla z této země bohužel nemůžeme odesílat SMS zprávy. Kontaktujte prosím svou praxi.",
    ru: "К сожалению, мы не можем отправлять SMS на номера из этой страны. Пожалуйста, свяжитесь с вашей клиникой.",
    hr: "Nažalost, ne možemo slati SMS na brojeve iz ove zemlje. Kontaktirajte svoju ordinaciju.",
    es: "Lamentablemente no podemos enviar SMS a números de este país. Póngase en contacto con su clínica.",
    fr: "Nous ne pouvons malheureusement pas envoyer de SMS aux numéros de ce pays. Veuillez contacter votre cabinet.",
    it: "Purtroppo non possiamo inviare SMS a numeri di questo paese. Contatta il tuo studio.",
    sq: "Fatkeqësisht nuk mund të dërgojmë SMS në numra nga ky vend. Ju lutem kontaktoni klinikën tuaj.",
  },
  SMS_LOGIN_ERROR_CAPTCHA: {
    de: "Die Sicherheitsprüfung hat nicht geklappt. Bitte versuchen Sie es noch einmal.",
    en: "The security check did not work. Please try again.",
    tr: "Güvenlik kontrolü başarısız oldu. Lütfen tekrar deneyin.",
    cs: "Bezpečnostní kontrola se nezdařila. Zkuste to prosím znovu.",
    ru: "Проверка безопасности не удалась. Пожалуйста, попробуйте снова.",
    hr: "Sigurnosna provjera nije uspjela. Pokušajte ponovo.",
    es: "La verificación de seguridad no funcionó. Inténtelo de nuevo.",
    fr: "La vérification de sécurité a échoué. Veuillez réessayer.",
    it: "Il controllo di sicurezza non è riuscito. Riprova.",
    sq: "Kontrolli i sigurisë nuk funksionoi. Ju lutem provoni përsëri.",
  },
  SMS_LOGIN_ERROR_CAPTCHA_BROWSER: {
    de: "Die Sicherheitsprüfung funktioniert in diesem Browser nicht. Bitte öffnen Sie den Link in Safari oder Chrome und schalten Sie einen Werbeblocker für diese Seite aus.",
    en: "The security check does not work in this browser. Please open the link in Safari or Chrome and switch off any ad blocker for this page.",
    tr: "Güvenlik kontrolü bu tarayıcıda çalışmıyor. Lütfen bağlantıyı Safari veya Chrome'da açın ve bu sayfa için reklam engelleyiciyi kapatın.",
    cs: "Bezpečnostní kontrola v tomto prohlížeči nefunguje. Otevřete prosím odkaz v Safari nebo Chrome a pro tuto stránku vypněte blokování reklam.",
    ru: "Проверка безопасности не работает в этом браузере. Пожалуйста, откройте ссылку в Safari или Chrome и отключите блокировщик рекламы для этой страницы.",
    hr: "Sigurnosna provjera ne radi u ovom pregledniku. Otvorite poveznicu u Safariju ili Chromeu i isključite blokator oglasa za ovu stranicu.",
    es: "La verificación de seguridad no funciona en este navegador. Abra el enlace en Safari o Chrome y desactive cualquier bloqueador de anuncios para esta página.",
    fr: "La vérification de sécurité ne fonctionne pas dans ce navigateur. Veuillez ouvrir le lien dans Safari ou Chrome et désactiver tout bloqueur de publicités pour cette page.",
    it: "Il controllo di sicurezza non funziona in questo browser. Apri il link in Safari o Chrome e disattiva eventuali ad blocker per questa pagina.",
    sq: "Kontrolli i sigurisë nuk funksionon në këtë shfletues. Ju lutem hapni lidhjen në Safari ose Chrome dhe çaktivizoni bllokuesin e reklamave për këtë faqe.",
  },
  SMS_LOGIN_ERROR_NETWORK: {
    de: "Keine Verbindung. Bitte prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
    en: "No connection. Please check your internet connection and try again.",
    tr: "Bağlantı yok. Lütfen internet bağlantınızı kontrol edip tekrar deneyin.",
    cs: "Žádné připojení. Zkontrolujte prosím své internetové připojení a zkuste to znovu.",
    ru: "Нет соединения. Пожалуйста, проверьте подключение к интернету и попробуйте снова.",
    hr: "Nema veze. Provjerite internetsku vezu i pokušajte ponovo.",
    es: "Sin conexión. Compruebe su conexión a internet e inténtelo de nuevo.",
    fr: "Pas de connexion. Veuillez vérifier votre connexion internet et réessayer.",
    it: "Nessuna connessione. Controlla la tua connessione internet e riprova.",
    sq: "Nuk ka lidhje. Ju lutem kontrolloni lidhjen tuaj të internetit dhe provoni përsëri.",
  },
  SMS_LOGIN_ERROR_BLOCKED: {
    de: "Diese Nummer ist gesperrt. Bitte wenden Sie sich an Ihre Praxis.",
    en: "This number is blocked. Please contact your practice.",
    tr: "Bu numara engellendi. Lütfen kliniğinizle iletişime geçin.",
    cs: "Toto číslo je zablokováno. Kontaktujte prosím svou praxi.",
    ru: "Этот номер заблокирован. Пожалуйста, свяжитесь с вашей клиникой.",
    hr: "Ovaj broj je blokiran. Kontaktirajte svoju ordinaciju.",
    es: "Este número está bloqueado. Póngase en contacto con su clínica.",
    fr: "Ce numéro est bloqué. Veuillez contacter votre cabinet.",
    it: "Questo numero è bloccato. Contatta il tuo studio.",
    sq: "Ky numër është i bllokuar. Ju lutem kontaktoni klinikën tuaj.",
  },
  SMS_LOGIN_ERROR_WRONG_CODE: {
    de: "Der Code stimmt nicht. Bitte prüfen Sie die SMS und geben Sie den Code erneut ein.",
    en: "The code is not correct. Please check the SMS and enter the code again.",
    tr: "Kod doğru değil. Lütfen SMS'i kontrol edip kodu tekrar girin.",
    cs: "Kód není správný. Zkontrolujte prosím SMS a zadejte kód znovu.",
    ru: "Код неверный. Пожалуйста, проверьте SMS и введите код снова.",
    hr: "Kod nije točan. Provjerite SMS i ponovno unesite kod.",
    es: "El código no es correcto. Compruebe el SMS e introduzca el código de nuevo.",
    fr: "Le code est incorrect. Veuillez vérifier le SMS et saisir à nouveau le code.",
    it: "Il codice non è corretto. Controlla l'SMS e inserisci di nuovo il codice.",
    sq: "Kodi nuk është i saktë. Ju lutem kontrolloni SMS-në dhe shkruani kodin përsëri.",
  },
  SMS_LOGIN_ERROR_CODE_EXPIRED: {
    de: "Der Code ist abgelaufen. Bitte fordern Sie einen neuen Code an.",
    en: "The code has expired. Please request a new code.",
    tr: "Kodun süresi doldu. Lütfen yeni bir kod isteyin.",
    cs: "Platnost kódu vypršela. Vyžádejte si prosím nový kód.",
    ru: "Срок действия кода истёк. Пожалуйста, запросите новый код.",
    hr: "Kod je istekao. Zatražite novi kod.",
    es: "El código ha caducado. Solicite un nuevo código.",
    fr: "Le code a expiré. Veuillez demander un nouveau code.",
    it: "Il codice è scaduto. Richiedi un nuovo codice.",
    sq: "Kodi ka skaduar. Ju lutem kërkoni një kod të ri.",
  },
  SMS_LOGIN_ERROR_RESTART: {
    de: "Die Anmeldung wurde unterbrochen. Bitte fordern Sie einen neuen Code an.",
    en: "The sign-in was interrupted. Please request a new code.",
    tr: "Giriş işlemi kesintiye uğradı. Lütfen yeni bir kod isteyin.",
    cs: "Přihlášení bylo přerušeno. Vyžádejte si prosím nový kód.",
    ru: "Вход был прерван. Пожалуйста, запросите новый код.",
    hr: "Prijava je prekinuta. Zatražite novi kod.",
    es: "El inicio de sesión se ha interrumpido. Solicite un nuevo código.",
    fr: "La connexion a été interrompue. Veuillez demander un nouveau code.",
    it: "L'accesso è stato interrotto. Richiedi un nuovo codice.",
    sq: "Identifikimi u ndërpre. Ju lutem kërkoni një kod të ri.",
  },
  SMS_LOGIN_ERROR_INVALID_LINK: {
    de: "Dieser Link ist ungültig. Bitte wenden Sie sich an Ihre Praxis.",
    en: "This link is invalid. Please contact your practice.",
    tr: "Bu bağlantı geçersiz. Lütfen kliniğinizle iletişime geçin.",
    cs: "Tento odkaz je neplatný. Kontaktujte prosím svou praxi.",
    ru: "Эта ссылка недействительна. Пожалуйста, свяжитесь с вашей клиникой.",
    hr: "Ova poveznica nije valjana. Kontaktirajte svoju ordinaciju.",
    es: "Este enlace no es válido. Póngase en contacto con su clínica.",
    fr: "Ce lien n'est pas valide. Veuillez contacter votre cabinet.",
    it: "Questo link non è valido. Contatta il tuo studio.",
    sq: "Kjo lidhje është e pavlefshme. Ju lutem kontaktoni klinikën tuaj.",
  },
  SMS_LOGIN_ERROR_TEST_LOCKED: {
    de: "Zu viele falsche Codes. Bitte wenden Sie sich an Ihre Praxis.",
    en: "Too many wrong codes. Please contact your practice.",
    tr: "Çok fazla yanlış kod girildi. Lütfen kliniğinizle iletişime geçin.",
    cs: "Příliš mnoho nesprávných kódů. Kontaktujte prosím svou praxi.",
    ru: "Слишком много неверных кодов. Пожалуйста, свяжитесь с вашей клиникой.",
    hr: "Previše netočnih kodova. Kontaktirajte svoju ordinaciju.",
    es: "Demasiados códigos incorrectos. Póngase en contacto con su clínica.",
    fr: "Trop de codes incorrects. Veuillez contacter votre cabinet.",
    it: "Troppi codici errati. Contatta il tuo studio.",
    sq: "Shumë kode të gabuara. Ju lutem kontaktoni klinikën tuaj.",
  },
  SMS_LOGIN_ERROR_GENERIC: {
    de: "Die Anmeldung hat nicht geklappt. Bitte versuchen Sie es erneut oder wenden Sie sich an Ihre Praxis.",
    en: "Signing in did not work. Please try again or contact your practice.",
    tr: "Giriş başarısız oldu. Lütfen tekrar deneyin veya kliniğinizle iletişime geçin.",
    cs: "Přihlášení se nezdařilo. Zkuste to prosím znovu nebo kontaktujte svou praxi.",
    ru: "Не удалось войти. Пожалуйста, попробуйте снова или свяжитесь с вашей клиникой.",
    hr: "Prijava nije uspjela. Pokušajte ponovo ili kontaktirajte svoju ordinaciju.",
    es: "El inicio de sesión no funcionó. Inténtelo de nuevo o póngase en contacto con su clínica.",
    fr: "La connexion a échoué. Veuillez réessayer ou contacter votre cabinet.",
    it: "L'accesso non è riuscito. Riprova o contatta il tuo studio.",
    sq: "Identifikimi nuk funksionoi. Ju lutem provoni përsëri ose kontaktoni klinikën tuaj.",
  },
  SMS_LOGIN_RELEASE_ENTRY: {
    de: "Anmeldecode eingeben",
    en: "Enter sign-in code",
    tr: "Giriş kodunu gir",
    cs: "Zadat přihlašovací kód",
    ru: "Ввести код для входа",
    hr: "Unesi kod za prijavu",
    es: "Introducir código de acceso",
    fr: "Entrer le code de connexion",
    it: "Inserisci codice di accesso",
    sq: "Shkruaj kodin e identifikimit",
  },
  RELEASE_CODE_HEADLINE: {
    de: "Anmeldecode eingeben",
    en: "Enter sign-in code",
    tr: "Giriş kodunu girin",
    cs: "Zadejte přihlašovací kód",
    ru: "Введите код для входа",
    hr: "Unesite kod za prijavu",
    es: "Ingrese el código de acceso",
    fr: "Entrez le code de connexion",
    it: "Inserisci il codice di accesso",
    sq: "Shkruani kodin e identifikimit",
  },
  RELEASE_CODE_TEXT: {
    de: "Geben Sie den Anmeldecode ein, den Sie am Empfang bekommen haben.",
    en: "Enter the sign-in code you received at the reception.",
    tr: "Resepsiyondan aldığınız giriş kodunu girin.",
    cs: "Zadejte přihlašovací kód, který jste dostali na recepci.",
    ru: "Введите код для входа, который вы получили на рецепции.",
    hr: "Unesite kod za prijavu koji ste dobili na recepciji.",
    es: "Introduzca el código de acceso que ha recibido en la recepción.",
    fr: "Entrez le code de connexion que vous avez reçu à la réception.",
    it: "Inserisci il codice di accesso che hai ricevuto alla reception.",
    sq: "Shkruani kodin e identifikimit që keni marrë në recepsion.",
  },
  RELEASE_SMS_LOGIN_ENTRY: {
    de: "Doch per SMS anmelden",
    en: "Sign in via SMS instead",
    tr: "Yine de SMS ile giriş yap",
    cs: "Raději se přihlásit přes SMS",
    ru: "Всё-таки войти по SMS",
    hr: "Ipak se prijavi SMS-om",
    es: "Iniciar sesión por SMS en su lugar",
    fr: "Se connecter plutôt par SMS",
    it: "Accedi invece tramite SMS",
    sq: "Identifikohu me SMS në vend të kësaj",
  },
  RELEASE_BIRTHDAY_HEADLINE: {
    de: "Ihr Geburtsdatum",
    en: "Your date of birth",
    tr: "Doğum tarihiniz",
    cs: "Vaše datum narození",
    ru: "Ваша дата рождения",
    hr: "Vaš datum rođenja",
    es: "Su fecha de nacimiento",
    fr: "Votre date de naissance",
    it: "La tua data di nascita",
    sq: "Datëlindja juaj",
  },
  RELEASE_BIRTHDAY_TEXT: {
    de: "Zur Sicherheit: Bitte geben Sie Ihr Geburtsdatum ein.",
    en: "For your security: please enter your date of birth.",
    tr: "Güvenliğiniz için: Lütfen doğum tarihinizi girin.",
    cs: "Pro jistotu: Zadejte prosím své datum narození.",
    ru: "Для безопасности: пожалуйста, введите вашу дату рождения.",
    hr: "Radi sigurnosti: unesite svoj datum rođenja.",
    es: "Por seguridad: introduzca su fecha de nacimiento.",
    fr: "Par sécurité : veuillez entrer votre date de naissance.",
    it: "Per sicurezza: inserisci la tua data di nascita.",
    sq: "Për siguri: ju lutem shkruani datëlindjen tuaj.",
  },
  RELEASE_ERROR_CODE_INVALID: {
    de: "Dieser Code ist nicht gültig. Ein Code gilt 15 Minuten und nur einmal. Bitte lassen Sie sich am Empfang einen neuen Code geben.",
    en: "This code is not valid. A code is valid for 15 minutes and only once. Please ask the reception for a new code.",
    tr: "Bu kod geçerli değil. Bir kod 15 dakika ve yalnızca bir kez geçerlidir. Lütfen resepsiyondan yeni bir kod isteyin.",
    cs: "Tento kód není platný. Kód platí 15 minut a jen jednou. Požádejte prosím na recepci o nový kód.",
    ru: "Этот код недействителен. Код действует 15 минут и только один раз. Пожалуйста, попросите новый код на рецепции.",
    hr: "Ovaj kod nije valjan. Kod vrijedi 15 minuta i samo jednom. Zatražite novi kod na recepciji.",
    es: "Este código no es válido. Un código es válido durante 15 minutos y solo una vez. Pida un código nuevo en la recepción.",
    fr: "Ce code n'est pas valide. Un code est valable 15 minutes et une seule fois. Veuillez demander un nouveau code à la réception.",
    it: "Questo codice non è valido. Un codice vale 15 minuti e una sola volta. Chiedi un nuovo codice alla reception.",
    sq: "Ky kod nuk është i vlefshëm. Një kod vlen 15 minuta dhe vetëm një herë. Ju lutem kërkoni një kod të ri në recepsion.",
  },
  RELEASE_ERROR_BIRTHDAY_WRONG: {
    de: "Das Geburtsdatum passt nicht. Bitte prüfen Sie Ihre Eingabe.",
    en: "The date of birth does not match. Please check your entry.",
    tr: "Doğum tarihi eşleşmiyor. Lütfen girdiğiniz bilgiyi kontrol edin.",
    cs: "Datum narození nesouhlasí. Zkontrolujte prosím zadané údaje.",
    ru: "Дата рождения не совпадает. Пожалуйста, проверьте введённые данные.",
    hr: "Datum rođenja se ne podudara. Provjerite unesene podatke.",
    es: "La fecha de nacimiento no coincide. Compruebe los datos introducidos.",
    fr: "La date de naissance ne correspond pas. Veuillez vérifier votre saisie.",
    it: "La data di nascita non corrisponde. Controlla i dati inseriti.",
    sq: "Datëlindja nuk përputhet. Ju lutem kontrolloni të dhënat e futura.",
  },
  RELEASE_ERROR_BURNED: {
    de: "Das Geburtsdatum passt nicht. Der Code ist jetzt gesperrt. Bitte wenden Sie sich an den Empfang.",
    en: "The date of birth does not match. The code is now blocked. Please contact the reception.",
    tr: "Doğum tarihi eşleşmiyor. Kod artık engellendi. Lütfen resepsiyona başvurun.",
    cs: "Datum narození nesouhlasí. Kód je nyní zablokován. Obraťte se prosím na recepci.",
    ru: "Дата рождения не совпадает. Код теперь заблокирован. Пожалуйста, обратитесь на рецепцию.",
    hr: "Datum rođenja se ne podudara. Kod je sada blokiran. Obratite se recepciji.",
    es: "La fecha de nacimiento no coincide. El código está bloqueado. Diríjase a la recepción.",
    fr: "La date de naissance ne correspond pas. Le code est maintenant bloqué. Veuillez vous adresser à la réception.",
    it: "La data di nascita non corrisponde. Il codice ora è bloccato. Rivolgiti alla reception.",
    sq: "Datëlindja nuk përputhet. Kodi tani është bllokuar. Ju lutem drejtohuni në recepsion.",
  },
  RELEASE_DONE_HEADLINE: {
    de: "Alles erledigt",
    en: "All done",
    tr: "Her şey tamam",
    cs: "Vše hotovo",
    ru: "Всё готово",
    hr: "Sve je gotovo",
    es: "Todo listo",
    fr: "C'est terminé",
    it: "Tutto fatto",
    sq: "Gjithçka është gati",
  },
  RELEASE_ENDED_HEADLINE: {
    de: "Sitzung beendet",
    en: "Session ended",
    tr: "Oturum sona erdi",
    cs: "Relace skončila",
    ru: "Сеанс завершён",
    hr: "Sesija je završena",
    es: "Sesión terminada",
    fr: "Session terminée",
    it: "Sessione terminata",
    sq: "Seanca përfundoi",
  },
  RELEASE_DONE_TEXT: {
    de: "Vielen Dank. Ihre Angaben sind bei Ihrer Praxis angekommen. Wenn Sie ein Gerät der Praxis nutzen, geben Sie es bitte am Empfang zurück.",
    en: "Thank you. Your details have reached your practice. If you are using a device of the practice, please return it to the reception.",
    tr: "Teşekkürler. Bilgileriniz kliniğinize ulaştı. Kliniğe ait bir cihaz kullanıyorsanız, lütfen resepsiyona geri verin.",
    cs: "Děkujeme. Vaše údaje dorazily do vaší praxe. Pokud používáte zařízení praxe, vraťte ho prosím na recepci.",
    ru: "Спасибо. Ваши данные поступили в вашу клинику. Если вы пользуетесь устройством клиники, пожалуйста, верните его на рецепцию.",
    hr: "Hvala. Vaši su podaci stigli u vašu ordinaciju. Ako koristite uređaj ordinacije, vratite ga na recepciju.",
    es: "Gracias. Sus datos han llegado a su clínica. Si está usando un dispositivo de la clínica, devuélvalo en la recepción.",
    fr: "Merci. Vos informations sont bien parvenues à votre cabinet. Si vous utilisez un appareil du cabinet, veuillez le rendre à la réception.",
    it: "Grazie. I tuoi dati sono arrivati al tuo studio. Se stai usando un dispositivo dello studio, restituiscilo alla reception.",
    sq: "Faleminderit. Të dhënat tuaja kanë mbërritur te klinika juaj. Nëse përdorni një pajisje të klinikës, ju lutem kthejeni në recepsion.",
  },
  RELEASE_ENDED_TEXT: {
    de: "Ihre Sitzung ist beendet. Für weitere Angaben lassen Sie sich bitte am Empfang einen neuen Code geben. Wenn Sie ein Gerät der Praxis nutzen, geben Sie es bitte am Empfang zurück.",
    en: "Your session has ended. To enter more details, please ask the reception for a new code. If you are using a device of the practice, please return it to the reception.",
    tr: "Oturumunuz sona erdi. Başka bilgi girmek için lütfen resepsiyondan yeni bir kod isteyin. Kliniğe ait bir cihaz kullanıyorsanız, lütfen resepsiyona geri verin.",
    cs: "Vaše relace skončila. Pro další údaje si prosím na recepci vyžádejte nový kód. Pokud používáte zařízení praxe, vraťte ho prosím na recepci.",
    ru: "Ваш сеанс завершён. Чтобы указать другие данные, пожалуйста, попросите новый код на рецепции. Если вы пользуетесь устройством клиники, пожалуйста, верните его на рецепцию.",
    hr: "Vaša sesija je završena. Za daljnje podatke zatražite novi kod na recepciji. Ako koristite uređaj ordinacije, vratite ga na recepciju.",
    es: "Su sesión ha terminado. Para añadir más datos, pida un código nuevo en la recepción. Si está usando un dispositivo de la clínica, devuélvalo en la recepción.",
    fr: "Votre session est terminée. Pour d'autres informations, veuillez demander un nouveau code à la réception. Si vous utilisez un appareil du cabinet, veuillez le rendre à la réception.",
    it: "La tua sessione è terminata. Per altri dati, chiedi un nuovo codice alla reception. Se stai usando un dispositivo dello studio, restituiscilo alla reception.",
    sq: "Seanca juaj ka përfunduar. Për të dhëna të tjera, ju lutem kërkoni një kod të ri në recepsion. Nëse përdorni një pajisje të klinikës, ju lutem kthejeni në recepsion.",
  },
  RELEASE_DONE_RETURN_BUTTON: {
    de: "Zurück zum Start",
    en: "Back to Start",
    tr: "Başa Dön",
    cs: "Zpět na začátek",
    ru: "Назад к началу",
    hr: "Natrag na početak",
    es: "Volver al inicio",
    fr: "Retour au début",
    it: "Torna all'inizio",
    sq: "Kthehu në fillim",
  },
  CHECKIN_HEADLINE: {
    de: "Willkommen zurück",
    en: "Welcome back",
    tr: "Tekrar hoş geldiniz",
    cs: "Vítejte zpět",
    ru: "С возвращением",
    hr: "Dobrodošli natrag",
    es: "Bienvenido de nuevo",
    fr: "Bon retour",
    it: "Bentornato",
    sq: "Mirësevini përsëri",
  },
  CHECKIN_DESCRIPTION: {
    de: "Wie geht es Ihnen seit dem letzten Termin? Das dauert nur ein bis zwei Minuten und hilft uns, Ihren Fortschritt transparent zu verfolgen.",
    en: "How are you since your last appointment? This takes only one to two minutes and helps us transparently track your progress.",
    tr: "Son randevunuzdan bu yana nasılsınız? Bu sadece bir ila iki dakika sürer ve ilerlemenizi şeffaf bir şekilde takip etmemize yardımcı olur.",
    cs: "Jak se cítíte od poslední návštěvy? Zabere to jen minutu nebo dvě a pomůže nám to transparentně sledovat váš pokrok.",
    ru: "Как вы себя чувствуете с момента последнего визита? Это займет всего 1-2 минуты и поможет нам отслеживать ваш прогресс.",
    hr: "Kako ste od zadnjeg termina? To traje samo minutu ili dvije i pomaže nam transparentno pratiti vaš napredak.",
    es: "¿Cómo ha estado desde su última cita? Esto toma solo uno o dos minutos y nos ayuda a seguir su progreso de manera transparente.",
    fr: "Comment allez-vous depuis votre dernier rendez-vous ? Cela ne prend qu'une ou deux minutes et nous aide à suivre vos progrès en toute transparence.",
    it: "Come stai dall'ultimo appuntamento? Ci vorranno solo uno o due minuti e ci aiuterà a tracciare i tuoi progressi in modo trasparente.",
    sq: "Si jeni që nga takimi i fundit? Kjo merr vetëm një ose dy minuta dhe na ndihmon të ndjekim përparimin tuaj në mënyrë transparente.",
  },
  PROGRESS_STEP: {
    de: "Schritt {{currentStep}} von {{totalSteps}}",
    en: "Step {{currentStep}} of {{totalSteps}}",
    tr: "{{totalSteps}} adımın {{currentStep}}. adımı",
    cs: "{{currentStep}}. krok z {{totalSteps}}",
    ru: "Шаг {{currentStep}} из {{totalSteps}}",
    hr: "{{currentStep}}. korak od {{totalSteps}}",
    es: "Paso {{currentStep}} de {{totalSteps}}",
    fr: "Étape {{currentStep}} sur {{totalSteps}}",
    it: "Passo {{currentStep}} di {{totalSteps}}",
    sq: "Hapi {{currentStep}} nga {{totalSteps}}",
  },
  ERROR_SOMETHING_WRONG: {
    de: "Etwas ist schief gelaufen",
    en: "Something went wrong",
    tr: "Bir şeyler yanlış gitti",
    cs: "Něco se pokazilo",
    ru: "Что-то пошло не так",
    hr: "Nešto je pošlo po zlu",
    es: "Algo salió mal",
    fr: "Quelque chose s'est mal passé",
    it: "Qualcosa è andato storto",
    sq: "Diçka shkoi keq",
  },
  ERROR_SAVING_ANSWERS: {
    de: "Deine Antworten konnten nicht gespeichert werden. Bitte versuche es erneut.",
    en: "Your answers could not be saved. Please try again.",
    tr: "Cevaplarınız kaydedilemedi. Lütfen tekrar deneyin.",
    cs: "Vaše odpovědi se nepodařilo uložit. Zkuste to prosím znovu.",
    ru: "Не удалось сохранить ваши ответы. Пожалуйста, попробуйте снова.",
    hr: "Vaši odgovori nisu mogli biti spremljeni. Molimo pokušajte ponovno.",
    es: "No se pudieron guardar sus respuestas. Por favor, inténtelo de nuevo.",
    fr: "Vos réponses n'ont pas pu être enregistrées. Veuillez réessayer.",
    it: "Non è stato possibile salvare le tue risposte. Riprova.",
    sq: "Përgjigjet tuaja nuk mund të ruheshin. Ju lutem provoni përsëri.",
  },
  ERROR_UPLOADING_DOCUMENTS: {
    de: "Fehler beim Hochladen der Dokumente, biite versuchen Sie es erneut",
    en: "Error uploading documents, please try again",
    tr: "Belgeleri yüklerken hata oluştu, lütfen tekrar deneyin",
    cs: "Chyba při nahrávání dokumentů, zkuste to prosím znovu",
    ru: "Ошибка при загрузке документов, пожалуйста, попробуйте снова",
    hr: "Greška pri učitavanju dokumenata, molimo pokušajte ponovno",
    es: "Error al subir los documentos, por favor inténtelo de nuevo",
    fr: "Erreur lors du téléchargement des documents, veuillez réessayer",
    it: "Errore durante il caricamento dei documenti, riprova",
    sq: "Gabim gjatë ngarkimit të dokumenteve, ju lutem provoni përsëri",
  },
  ERROR_PAGE_NOT_FOUND: {
    de: "Seite nicht gefunden",
    en: "Page not found",
    tr: "Sayfa bulunamadı",
    cs: "Stránka nenalezena",
    ru: "Страница не найдена",
    hr: "Stranica nije pronađena",
    es: "Página no encontrada",
    fr: "Page non trouvée",
    it: "Pagina non trovata",
    sq: "Faqja nuk u gjet",
  },
  ERROR_LOADING_DESCRIPTION: {
    de: "Beim Laden der Seite ist etwas schief gelaufen. Bitte entschuldige und versuche es erneut.",
    en: "Something went wrong while loading the page. Please excuse us and try again.",
    tr: "Sayfa yüklenirken bir şeyler yanlış gitti. Lütfen affedersiniz ve tekrar deneyin.",
    cs: "Při načítání stránky došlo k chybě. Omlouváme se, zkuste to prosím znovu.",
    ru: "При загрузке страницы произошла ошибка. Извините и попробуйте снова.",
    hr: "Došlo je do pogreške prilikom učitavanja stranice. Ispričavamo se, pokušajte ponovno.",
    es: "Algo salió mal al cargar la página. Disculpe y vuelva a intentarlo.",
    fr: "Une erreur s'est produite lors du chargement de la page. Veuillez nous excuser et réessayer.",
    it: "Qualcosa è andato storto durante il caricamento della pagina. Ci scusiamo e riprova.",
    sq: "Diçka shkoi keq gjatë ngarkimit të faqes. Ju lutem na falni dhe provoni përsëri.",
  },
  ERROR_NOT_FOUND_DESCRIPTION: {
    de: "Die angeforderte Seite konnte nicht gefunden werden. Kehre zur Startseite zurück oder kontaktiere uns für Hilfe.",
    en: "The requested page could not be found. Return to the homepage or contact us for help.",
    tr: "İstenen sayfa bulunamadı. Ana sayfaya dönün veya yardım için bizimle iletişime geçin.",
    cs: "Požadovaná stránka nebyla nalezena. Vraťte se na domovskou stránku nebo nás kontaktujte.",
    ru: "Запрашиваемая страница не найдена. Вернитесь на главную или свяжитесь с нами.",
    hr: "Tražena stranica nije pronađena. Vratite se na početnu stranicu ili nas kontaktirajte.",
    es: "La página solicitada no pudo ser encontrada. Regrese a la página de inicio o contáctenos.",
    fr: "La page demandée est introuvable. Retournez à la page d'accueil ou contactez-nous.",
    it: "La pagina richiesta non è stata trovata. Torna alla home page o contattaci.",
    sq: "Faqja e kërkuar nuk u gjet. Kthehuni në faqen kryesore ose na kontaktoni.",
  },
  ERROR_RELOAD_PAGE: {
    de: "Seite neu laden",
    en: "Reload page",
    tr: "Sayfayı yenile",
    cs: "Obnovit stránku",
    ru: "Перезагрузить страницу",
    hr: "Ponovo učitaj stranicu",
    es: "Recargar página",
    fr: "Recharger la page",
    it: "Ricarica pagina",
    sq: "Ringarko faqen",
  },
  ERROR_BACK_TO_HOME: {
    de: "Zurück zur Startseite",
    en: "Back to homepage",
    tr: "Ana sayfaya dön",
    cs: "Zpět na úvodní stránku",
    ru: "Вернуться на главную",
    hr: "Natrag na početnu",
    es: "Volver al inicio",
    fr: "Retour à l'accueil",
    it: "Torna alla home",
    sq: "Kthehu në faqen kryesore",
  },
  SUCCESS_DATA_SAVED: {
    de: "Vielen Dank für Ihre Zeit. Ihre Angaben wurden gespeichert.",
    en: "Thank you for your time. Your information has been saved.",
    tr: "Zamanınız için teşekkür ederiz. Bilgileriniz kaydedildi.",
    cs: "Děkujeme za váš čas. Vaše údaje byly uloženy.",
    ru: "Спасибо за ваше время. Ваши данные сохранены.",
    hr: "Hvala na vašem vremenu. Vaši podaci su spremljeni.",
    es: "Gracias por su tiempo. Su información ha sido guardada.",
    fr: "Merci pour votre temps. Vos informations ont été enregistrées.",
    it: "Grazie per il tuo tempo. Le tue informazioni sono state salvate.",
    sq: "Faleminderit për kohën tuaj. Informacioni juaj është ruajtur.",
  },
  CAMERA_PREVIOUS_PHOTO: {
    de: "Vorher aufgenommenes Foto",
    en: "Previously taken photo",
    tr: "Önceden çekilmiş fotoğraf",
    cs: "Dříve pořízená fotografie",
    ru: "Ранее сделанное фото",
    hr: "Prethodno snimljena fotografija",
    es: "Foto tomada anteriormente",
    fr: "Photo prise précédemment",
    it: "Foto scattata in precedenza",
    sq: "Foto e bërë më parë",
  },
  CAMERA_CAPTURED_PHOTO: {
    de: "Aufgenommenes Foto",
    en: "Captured photo",
    tr: "Çekilmiş fotoğraf",
    cs: "Pořízená fotografie",
    ru: "Сделанное фото",
    hr: "Snimljena fotografija",
    es: "Foto capturada",
    fr: "Photo capturée",
    it: "Foto acquisita",
    sq: "Foto e kapur",
  },
  CAMERA_NO_CAMERA: {
    de: "Keine Kamera verfügbar",
    en: "No camera available",
    tr: "Kamera mevcut değil",
    cs: "Kamera není k dispozici",
    ru: "Камера недоступна",
    hr: "Kamera nije dostupna",
    es: "No hay cámara disponible",
    fr: "Aucune caméra disponible",
    it: "Nessuna fotocamera disponibile",
    sq: "Nuk ka kamerë të disponueshme",
  },
  CAMERA_NO_CAMERA_DESCRIPTION: {
    de: "Es wurde keine Kamera gefunden. Bitte verwenden Sie ein Gerät mit Kamera.",
    en: "No camera was found. Please use a device with a camera.",
    tr: "Kamera bulunamadı. Lütfen kameralı bir cihaz kullanın.",
    cs: "Kamera nebyla nalezena. Použijte prosím zařízení s kamerou.",
    ru: "Камера не найдена. Пожалуйста, используйте устройство с камерой.",
    hr: "Kamera nije pronađena. Molimo koristite uređaj s kamerom.",
    es: "No se encontró ninguna cámara. Por favor use un dispositivo con cámara.",
    fr: "Aucune caméra trouvée. Veuillez utiliser un appareil avec une caméra.",
    it: "Nessuna fotocamera trovata. Usa un dispositivo con fotocamera.",
    sq: "Nuk u gjet kamerë. Ju lutem përdorni një pajisje me kamerë.",
  },
  CAMERA_ACCESS_REQUIRED: {
    de: "Kamera-Zugriff erforderlich",
    en: "Camera access required",
    tr: "Kamera erişimi gerekli",
    cs: "Vyžadován přístup ke kameře",
    ru: "Требуется доступ к камере",
    hr: "Potreban pristup kameri",
    es: "Acceso a la cámara requerido",
    fr: "Accès à la caméra requis",
    it: "Accesso alla fotocamera richiesto",
    sq: "Kërkohet qasje në kamerë",
  },
  CAMERA_ACCESS_REQUIRED_DESCRIPTION: {
    de: "Bitte erlauben Sie den Zugriff auf die Kamera, um Fotos aufzunehmen.",
    en: "Please allow access to the camera to take photos.",
    tr: "Fotoğraf çekmek için lütfen kameraya erişim izni verin.",
    cs: "Povolte prosím přístup ke kameře pro pořizování fotografií.",
    ru: "Пожалуйста, разрешите доступ к камере для фотосъемки.",
    hr: "Molimo dopustite pristup kameri za snimanje fotografija.",
    es: "Por favor permita el acceso a la cámara para tomar fotos.",
    fr: "Veuillez autoriser l'accès à la caméra pour prendre des photos.",
    it: "Consenti l'accesso alla fotocamera per scattare foto.",
    sq: "Ju lutem lejoni qasjen në kamerë për të bërë foto.",
  },
  CAMERA_REQUEST_ACCESS: {
    de: "Kamera-Zugriff anfragen",
    en: "Request camera access",
    tr: "Kamera erişimi iste",
    cs: "Požádat o přístup ke kameře",
    ru: "Запросить доступ к камере",
    hr: "Zatraži pristup kameri",
    es: "Solicitar acceso a la cámara",
    fr: "Demander l'accès à la caméra",
    it: "Richiedi accesso fotocamera",
    sq: "Kërko qasje në kamerë",
  },
  CAMERA_ACCESS_DENIED: {
    de: "Kamera-Zugriff verweigert",
    en: "Camera access denied",
    tr: "Kamera erişimi reddedildi",
    cs: "Přístup ke kameře odepřen",
    ru: "Доступ к камере запрещен",
    hr: "Pristup kameri odbijen",
    es: "Acceso a la cámara denegado",
    fr: "Accès à la caméra refusé",
    it: "Accesso fotocamera negato",
    sq: "Qasja në kamerë u refuzua",
  },
  CAMERA_ACCESS_DENIED_DESCRIPTION: {
    de: "Bitte erlauben Sie den Zugriff auf die Kamera in Ihren Browser-Einstellungen und laden Sie die Seite neu.",
    en: "Please allow camera access in your browser settings and reload the page.",
    tr: "Lütfen tarayıcı ayarlarınızdan kamera erişimine izin verin ve sayfayı yenileyin.",
    cs: "Povolte přístup ke kameře v nastavení prohlížeče a obnovte stránku.",
    ru: "Разрешите доступ к камере в настройках браузера и обновите страницу.",
    hr: "Dopustite pristup kameri u postavkama preglednika i ponovno učitajte stranicu.",
    es: "Permita el acceso a la cámara en la configuración de su navegador y recargue la página.",
    fr: "Veuillez autoriser l'accès à la caméra dans les paramètres de votre navigateur et recharger la page.",
    it: "Consenti l'accesso alla fotocamera nelle impostazioni del browser e ricarica la pagina.",
    sq: "Ju lutem lejoni qasjen në kamerë në cilësimet e shfletuesit tuaj dhe rifreskoni faqen.",
  },
  CAMERA_RELOAD_PAGE: {
    de: "Seite neu laden",
    en: "Reload page",
    tr: "Sayfayı yenile",
    cs: "Obnovit stránku",
    ru: "Обновить страницу",
    hr: "Ponovo učitaj stranicu",
    es: "Recargar página",
    fr: "Recharger la page",
    it: "Ricarica pagina",
    sq: "Ringarko faqen",
  },
  CAMERA_LOADING: {
    de: "Kamera wird geladen...",
    en: "Camera loading...",
    tr: "Kamera yükleniyor...",
    cs: "Načítání kamery...",
    ru: "Загрузка камеры...",
    hr: "Učitavanje kamere...",
    es: "Cargando cámara...",
    fr: "Chargement de la caméra...",
    it: "Caricamento fotocamera...",
    sq: "Kamera po ngarkohet...",
  },
  CAMERA_LOADING_DESCRIPTION: {
    de: "Bitte warten Sie, während die Kamera initialisiert wird.",
    en: "Please wait while the camera is being initialized.",
    tr: "Kamera başlatılırken lütfen bekleyin.",
    cs: "Počkejte prosím, než se kamera inicializuje.",
    ru: "Пожалуйста, подождите, пока камера инициализируется.",
    hr: "Molimo pričekajte dok se kamera inicijalizira.",
    es: "Por favor espere mientras se inicializa la cámara.",
    fr: "Veuillez patienter pendant l'initialisation de la caméra.",
    it: "Attendi mentre la fotocamera viene inizializzata.",
    sq: "Ju lutem prisni derisa kamera të inicializohet.",
  },
  CAMERA_RETRY: {
    de: "Wiederholen",
    en: "Try again",
    tr: "Tekrar dene",
    cs: "Zkusit znovu",
    ru: "Попробовать снова",
    hr: "Pokušaj ponovo",
    es: "Intentar de nuevo",
    fr: "Réessayer",
    it: "Riprova",
    sq: "Provo përsëri",
  },
  CAMERA_CAPTURING: {
    de: "Aufnahme...",
    en: "Capturing...",
    tr: "Çekiliyor...",
    cs: "Snímání...",
    ru: "Съемка...",
    hr: "Snimanje...",
    es: "Capturando...",
    fr: "Capture...",
    it: "Acquisizione...",
    sq: "Duke kapur...",
  },
  CAMERA_TAKE_PHOTO: {
    de: "Foto aufnehmen",
    en: "Take photo",
    tr: "Fotoğraf çek",
    cs: "Vyfotit",
    ru: "Сделать фото",
    hr: "Uslikaj",
    es: "Tomar foto",
    fr: "Prendre une photo",
    it: "Scatta foto",
    sq: "Bëj foto",
  },
  HOME_OVERVIEW: {
    de: "Übersicht",
    en: "Overview",
    tr: "Genel Bakış",
    cs: "Přehled",
    ru: "Обзор",
    hr: "Pregled",
    es: "Visión general",
    fr: "Aperçu",
    it: "Panoramica",
    sq: "Përmbledhje",
  },
  HOME_OVERVIEW_DESCRIPTION: {
    de: "Hier finden Sie eine Übersicht über Ihre Formulare.",
    en: "Here you will find an overview of your forms.",
    tr: "Burada formlarınızın genel bakışını bulabilirsiniz.",
    cs: "Zde naleznete přehled vašich formulářů.",
    ru: "Здесь вы найдете обзор ваших форм.",
    hr: "Ovdje ćete pronaći pregled vaših obrazaca.",
    es: "Aquí encontrará una visión general de sus formularios.",
    fr: "Vous trouverez ici un aperçu de vos formulaires.",
    it: "Qui troverai una panoramica dei tuoi moduli.",
    sq: "Këtu do të gjeni një përmbledhje të formularëve tuaj.",
  },
  CONTRACT_COMPLETED_TITLE: {
    de: "Abgeschlossen",
    en: "Completed",
    tr: "Tamamlandı",
    cs: "Dokončeno",
    ru: "Завершено",
    hr: "Završeno",
    es: "Completado",
    fr: "Terminé",
    it: "Completato",
    sq: "Përfunduar",
  },
  CONTRACT_COMPLETED_BODY: {
    de: "Vertrag erfolgreich unterschrieben",
    en: "Contract successfully signed",
    tr: "Sözleşme başarıyla imzalandı",
    cs: "Smlouva úspěšně podepsána",
    ru: "Договор успешно подписан",
    hr: "Ugovor uspješno potpisan",
    es: "Contrato firmado con éxito",
    fr: "Contrat signé avec succès",
    it: "Contratto firmato con successo",
    sq: "Kontrata u nënshkrua me sukses",
  },
  BODY_ORIENTATION_FRONT: {
    de: "Vorne",
    en: "Front",
    tr: "Ön",
    cs: "Přední",
    ru: "Спереди",
    hr: "Naprijed",
    es: "Frente",
    fr: "Devant",
    it: "Fronte",
    sq: "Para",
  },
  BODY_ORIENTATION_BACK: {
    de: "Hinten",
    en: "Back",
    tr: "Arka",
    cs: "Zadní",
    ru: "Сзади",
    hr: "Natrag",
    es: "Atrás",
    fr: "Derrière",
    it: "Retro",
    sq: "Mbrapa",
  },
  BODY_ORIENTATION_RIGHT: {
    de: "Rechts",
    en: "Right",
    tr: "Sağ",
    cs: "Vpravo",
    ru: "Справа",
    hr: "Desno",
    es: "Derecha",
    fr: "Droite",
    it: "Destra",
    sq: "Djathtas",
  },
  BODY_ORIENTATION_LEFT: {
    de: "Links",
    en: "Left",
    tr: "Sol",
    cs: "Vlevo",
    ru: "Слева",
    hr: "Lijevo",
    es: "Izquierda",
    fr: "Gauche",
    it: "Sinistra",
    sq: "Majtas",
  },
  BODY_ORIENTATION_YOUR_RIGHT: {
    de: "Ihr Rechts",
    en: "Your Right",
    tr: "Sizin Sağınız",
    cs: "Vaše pravá",
    ru: "Ваше право",
    hr: "Vaše desno",
    es: "Su derecha",
    fr: "Votre droite",
    it: "La tua destra",
    sq: "E djathta juaj",
  },
  BODY_ORIENTATION_YOUR_LEFT: {
    de: "Ihr Links",
    en: "Your Left",
    tr: "Sizin Solunuz",
    cs: "Vaše levá",
    ru: "Ваше лево",
    hr: "Vaše lijevo",
    es: "Su izquierda",
    fr: "Votre gauche",
    it: "La tua sinistra",
    sq: "E majta juaj",
  },
  COUNTRY_LABEL: {
    de: "Land",
    en: "Country",
    tr: "Ülke",
    cs: "Země",
    ru: "Страна",
    hr: "Država",
    es: "País",
    fr: "Pays",
    it: "Paese",
    sq: "Shteti",
  },
  PHONE_NUMBER_LABEL: {
    de: "Telefonnummer",
    en: "Phone Number",
    tr: "Telefon Numarası",
    cs: "Telefonní číslo",
    ru: "Номер телефона",
    hr: "Broj telefona",
    es: "Número de teléfono",
    fr: "Numéro de téléphone",
    it: "Numero di telefono",
    sq: "Numri i telefonit",
  },
  STREET: {
    de: "Straße und Hausnummer",
    en: "Street",
    tr: "Cadde ve Kapı Numarası",
    cs: "Ulice a číslo popisné",
    ru: "Улица и номер дома",
    hr: "Ulica i kućni broj",
    es: "Calle y número",
    fr: "Rue et numéro",
    it: "Via e numero civico",
    sq: "Rruga dhe numri i shtëpisë",
  },
  ZIP: {
    de: "PLZ",
    en: "Zip Code",
    tr: "Posta Kodu",
    cs: "PSČ",
    ru: "Индекс",
    hr: "Poštanski broj",
    es: "Código postal",
    fr: "Code postal",
    it: "CAP",
    sq: "Kodi postar",
  },
  CITY: {
    de: "Ort",
    en: "City",
    tr: "Şehir",
    cs: "Město",
    ru: "Город",
    hr: "Grad",
    es: "Ciudad",
    fr: "Ville",
    it: "Città",
    sq: "Qyteti",
  },
  APPOINTMENT_SUBMIT_REQUEST: {
    de: "Anfrage absenden",
    en: "Submit Request",
    tr: "Talep Gönder",
    cs: "Odeslat žádost",
    ru: "Отправить запрос",
    hr: "Pošalji zahtjev",
    es: "Enviar solicitud",
    fr: "Envoyer la demande",
    it: "Invia richiesta",
    sq: "Dërgo kërkesën",
  },
  APPOINTMENT_CONTACT_HEADLINE: {
    de: "Kontaktdaten eingeben",
    en: "Contact Information",
    tr: "İletişim Bilgileri",
    cs: "Kontaktní údaje",
    ru: "Контактная информация",
    hr: "Kontakt podaci",
    es: "Información de contacto",
    fr: "Coordonnées",
    it: "Dati di contatto",
    sq: "Të dhënat e kontaktit",
  },
  APPOINTMENT_STEP_4_OF_4: {
    de: "Schritt 4 von 4",
    en: "Step 4 of 4",
    tr: "Adım 4/4",
    cs: "Krok 4 z 4",
    ru: "Шаг 4 из 4",
    hr: "Korak 4 od 4",
    es: "Paso 4 de 4",
    fr: "Étape 4 sur 4",
    it: "Passo 4 di 4",
    sq: "Hapi 4 nga 4",
  },
  APPOINTMENT_CONTACT_DESCRIPTION: {
    de: "Bitte tragen Sie Ihre Kontaktdaten vollständig ein.",
    en: "Please fill in your information completely.",
    tr: "Lütfen bilgilerinizi eksiksiz olarak doldurun.",
    cs: "Vyplňte prosím své údaje úplně.",
    ru: "Пожалуйста, заполните ваши данные полностью.",
    hr: "Molimo vas da u potpunosti ispunite svoje podatke.",
    es: "Por favor complete su información completamente.",
    fr: "Veuillez remplir vos informations complètement.",
    it: "Completa i tuoi dati.",
    sq: "Ju lutem plotësoni të dhënat tuaja plotësisht.",
  },
  APPOINTMENT_FIRST_NAME: {
    de: "Vorname",
    en: "First Name",
    tr: "Ad",
    cs: "Jméno",
    ru: "Имя",
    hr: "Ime",
    es: "Nombre",
    fr: "Prénom",
    it: "Nome",
    sq: "Emri",
  },
  APPOINTMENT_LAST_NAME: {
    de: "Nachname",
    en: "Last Name",
    tr: "Soyad",
    cs: "Příjmení",
    ru: "Фамилия",
    hr: "Prezime",
    es: "Apellido",
    fr: "Nom",
    it: "Cognome",
    sq: "Mbiemri",
  },
  APPOINTMENT_EMAIL: {
    de: "E-Mail",
    en: "Email",
    tr: "E-posta",
    cs: "E-mail",
    ru: "Эл. почта",
    hr: "E-mail",
    es: "Correo electrónico",
    fr: "E-mail",
    it: "E-mail",
    sq: "E-mail",
  },
  APPOINTMENT_INSURANCE: {
    de: "Krankenkasse",
    en: "Insurance",
    tr: "Sigorta",
    cs: "Pojišťovna",
    ru: "Страховая компания",
    hr: "Osiguranje",
    es: "Seguro",
    fr: "Assurance",
    it: "Assicurazione",
    sq: "Sigurimi shëndetësor",
  },
  APPOINTMENT_BIRTHDAY: {
    de: "Geburtsdatum",
    en: "Date of Birth",
    tr: "Doğum Tarihi",
    cs: "Datum narození",
    ru: "Дата рождения",
    hr: "Datum rođenja",
    es: "Fecha de nacimiento",
    fr: "Date de naissance",
    it: "Data di nascita",
    sq: "Datëlindja",
  },
  INVALID_DATE: {
    de: "Ungültiges Datum",
    en: "Invalid date",
    tr: "Geçersiz tarih",
    cs: "Neplatné datum",
    ru: "Неверная дата",
    hr: "Nevažeći datum",
    es: "Fecha inválida",
    fr: "Date invalide",
    it: "Data non valida",
    sq: "Datë e pavlefshme",
  },
  APPOINTMENT_CALLBACK_NUMBER: {
    de: "Rückrufnummer",
    en: "Callback Number",
    tr: "Geri Arama Numarası",
    cs: "Telefon pro zpětné volání",
    ru: "Номер для обратного звонка",
    hr: "Broj za povratni poziv",
    es: "Número de devolución de llamada",
    fr: "Numéro de rappel",
    it: "Numero di richiamata",
    sq: "Numri për t'ju thirrur",
  },
  APPOINTMENT_PRIVACY_AGREEMENT: {
    de: "Ich stimme der Datenschutzerklärung zu.",
    en: "I agree to the privacy policy.",
    tr: "Gizlilik politikasını kabul ediyorum.",
    cs: "Souhlasím se zásadami ochrany osobních údajů.",
    ru: "Я согласен с политикой конфиденциальности.",
    hr: "Slažem se s pravilima o privatnosti.",
    es: "Estoy de acuerdo con la política de privacidad.",
    fr: "J'accepte la politique de confidentialité.",
    it: "Accetto l'informativa sulla privacy.",
    sq: "Pajtohem me politikën e privatësisë.",
  },
  TIME_SLOT_MORNING: {
    de: "Morgens",
    en: "Morning",
    tr: "Sabah",
    cs: "Ráno",
    ru: "Утро",
    hr: "Jutro",
    es: "Mañana",
    fr: "Matin",
    it: "Mattina",
    sq: "Mëngjes",
  },
  TIME_SLOT_AFTERNOON: {
    de: "Mittags",
    en: "Afternoon",
    tr: "Öğlen",
    cs: "Odpoledne",
    ru: "День",
    hr: "Poslijepodne",
    es: "Tarde",
    fr: "Après-midi",
    it: "Pomeriggio",
    sq: "Pasdite",
  },
  TIME_SLOT_EVENING: {
    de: "Abends",
    en: "Evening",
    tr: "Akşam",
    cs: "Večer",
    ru: "Вечер",
    hr: "Večer",
    es: "Noche",
    fr: "Soir",
    it: "Sera",
    sq: "Mbrëmje",
  },
  TIME_SLOT_MORNING_HOURS: {
    de: "8-12",
    en: "8-12 AM",
    tr: "8-12",
    cs: "8-12",
    ru: "8-12",
    hr: "8-12",
    es: "8-12",
    fr: "8-12",
    it: "8-12",
    sq: "8-12",
  },
  TIME_SLOT_AFTERNOON_HOURS: {
    de: "12-16",
    en: "12-4 PM",
    tr: "12-16",
    cs: "12-16",
    ru: "12-16",
    hr: "12-16",
    es: "12-16",
    fr: "12-16",
    it: "12-16",
    sq: "12-16",
  },
  TIME_SLOT_EVENING_HOURS: {
    de: "16-20",
    en: "4-8 PM",
    tr: "16-20",
    cs: "16-20",
    ru: "16-20",
    hr: "16-20",
    es: "16-20",
    fr: "16-20",
    it: "16-20",
    sq: "16-20",
  },
  TIME_SLOT_ALL: {
    de: "Alle",
    en: "All",
    tr: "Hepsi",
    cs: "Vše",
    ru: "Все",
    hr: "Sve",
    es: "Todos",
    fr: "Tous",
    it: "Tutti",
    sq: "Të gjitha",
  },
  DAY_MONDAY_SHORT: {
    de: "Mo",
    en: "Mon",
    tr: "Pzt",
    cs: "Po",
    ru: "Пн",
    hr: "Pon",
    es: "Lun",
    fr: "Lun",
    it: "Lun",
    sq: "Hën",
  },
  DAY_TUESDAY_SHORT: {
    de: "Di",
    en: "Tue",
    tr: "Sal",
    cs: "Út",
    ru: "Вт",
    hr: "Uto",
    es: "Mar",
    fr: "Mar",
    it: "Mar",
    sq: "Mar",
  },
  DAY_WEDNESDAY_SHORT: {
    de: "Mi",
    en: "Wed",
    tr: "Çar",
    cs: "St",
    ru: "Ср",
    hr: "Sri",
    es: "Mié",
    fr: "Mer",
    it: "Mer",
    sq: "Mër",
  },
  DAY_THURSDAY_SHORT: {
    de: "Do",
    en: "Thu",
    tr: "Per",
    cs: "Čt",
    ru: "Чт",
    hr: "Čet",
    es: "Jue",
    fr: "Jeu",
    it: "Gio",
    sq: "Enj",
  },
  DAY_FRIDAY_SHORT: {
    de: "Fr",
    en: "Fri",
    tr: "Cum",
    cs: "Pá",
    ru: "Пт",
    hr: "Pet",
    es: "Vie",
    fr: "Ven",
    it: "Ven",
    sq: "Pre",
  },
  DAY_SATURDAY_SHORT: {
    de: "Sa",
    en: "Sat",
    tr: "Cmt",
    cs: "So",
    ru: "Сб",
    hr: "Sub",
    es: "Sáb",
    fr: "Sam",
    it: "Sab",
    sq: "Sht",
  },
  DAY_SUNDAY_SHORT: {
    de: "So",
    en: "Sun",
    tr: "Paz",
    cs: "Ne",
    ru: "Вс",
    hr: "Ned",
    es: "Dom",
    fr: "Dim",
    it: "Dom",
    sq: "Die",
  },
  APPOINTMENT_RECIPE_HEADLINE: {
    de: "Rezept hochladen",
    en: "Upload Prescription",
    tr: "Reçete Yükle",
    cs: "Nahrát recept",
    ru: "Загрузить рецепт",
    hr: "Učitaj recept",
    es: "Subir receta",
    fr: "Télécharger l'ordonnance",
    it: "Carica ricetta",
    sq: "Ngarko recetën",
  },
  APPOINTMENT_RECIPE_DESCRIPTION: {
    de: "Bitte laden Sie nur die Vorderseite Ihres Rezepts hoch.",
    en: "Please upload your prescription so we can quickly find a suitable appointment for you.",
    tr: "Size uygun bir randevu bulabilmemiz için lütfen reçetenizi yükleyiniz.",
    cs: "Nahrajte prosím svůj recept, abychom pro vás mohli rychle najít vhodný termín.",
    ru: "Пожалуйста, загрузите свой рецепт, чтобы мы могли быстро найти для вас подходящее время.",
    hr: "Molimo prenesite svoj recept kako bismo vam mogli brzo pronaći odgovarajući termin.",
    es: "Por favor suba su receta para que podamos encontrar rápidamente una cita adecuada para usted.",
    fr: "Veuillez télécharger votre ordonnance afin que nous puissions rapidement trouver un rendez-vous qui vous convient.",
    it: "Carica la tua ricetta in modo che possiamo trovare rapidamente un appuntamento adatto a te.",
    sq: "Ju lutem ngarkoni recetën tuaj në mënyrë që të gjejmë shpejt një takim të përshtatshëm për ju.",
  },
  APPOINTMENT_RECIPE_TAKE_PHOTO: {
    de: "Rezept fotografieren",
    en: "Take Photo of Prescription",
    tr: "Reçete Fotoğrafı Çek",
    cs: "Vyfotit recept",
    ru: "Сфотографировать рецепт",
    hr: "Uslikaj recept",
    es: "Tomar foto de la receta",
    fr: "Prendre une photo de l'ordonnance",
    it: "Scatta foto della ricetta",
    sq: "Bëj foto recetës",
  },
  APPOINTMENT_RECIPE_UPLOAD: {
    de: "Rezept jetzt hochladen",
    en: "Upload prescription now",
    tr: "Reçeteyi şimdi yükle",
    cs: "Nahrát recept nyní",
    ru: "Загрузить рецепт сейчас",
    hr: "Učitaj recept sada",
    es: "Subir receta ahora",
    fr: "Télécharger l'ordonnance maintenant",
    it: "Carica ricetta ora",
    sq: "Ngarko recetën tani",
  },
  APPOINTMENT_RECIPE_SELF_PAYER: {
    de: "Ich bin Selbstzahler",
    en: "I am a self-payer",
    tr: "Masrafları kendim karşılıyorum",
    cs: "Jsem samoplátce",
    ru: "Я оплачиваю самостоятельно",
    hr: "Sam plaćam",
    es: "Soy pagador propio",
    fr: "Je paie moi-même",
    it: "Pago di tasca mia",
    sq: "Paguaj vetë",
  },
  APPOINTMENT_NO_RECIPE: {
    de: "Ich habe kein Rezept",
    en: "I don't have a prescription",
    tr: "Reçetem yok",
    cs: "Nemám recept",
    ru: "У меня нет рецепта",
    hr: "Nemam recept",
    es: "No tengo receta",
    fr: "Je n'ai pas d'ordonnance",
    it: "Non ho una ricetta",
    sq: "Nuk kam recetë",
  },
  APPOINTMENT_NO_RECIPE_HINT_LINE_1: {
    de: "Terminanfragen sind aktuell nur mit Rezept möglich.",
    en: "Appointment requests are currently only possible with a prescription.",
    tr: "Randevu talepleri şu anda yalnızca reçete ile mümkündür.",
    cs: "Žádosti o termín jsou momentálně možné pouze s receptem.",
    ru: "Запросы на приём в настоящее время возможны только с рецептом.",
    hr: "Zahtjevi za termin trenutno su mogući samo s receptom.",
    es: "Las solicitudes de cita actualmente solo son posibles con una receta.",
    fr: "Les demandes de rendez-vous sont actuellement possibles uniquement avec une ordonnance.",
    it: "Al momento le richieste di appuntamento sono possibili solo con una prescrizione.",
    sq: "Kërkesat për termin aktualisht janë të mundshme vetëm me recetë.",
  },
  APPOINTMENT_NO_RECIPE_HINT_LINE_2: {
    de: "Sind Sie Selbstzahler? Dann wählen Sie die Option „Ich bin Selbstzahler“.",
    en: "Are you a self-payer? Then select the option “I am a self-payer”.",
    tr: "Masrafları kendiniz mi karşılıyorsunuz? O zaman “Masrafları kendim karşılıyorum” seçeneğini seçin.",
    cs: "Jste samoplátce? Pak vyberte možnost „Jsem samoplátce“.",
    ru: "Вы оплачиваете самостоятельно? Тогда выберите вариант «Я оплачиваю самостоятельно».",
    hr: "Plaćate li sami? Tada odaberite opciju „Sam plaćam“.",
    es: "¿Es usted pagador propio? Entonces seleccione la opción “Soy pagador propio”.",
    fr: "Payez-vous vous-même ? Sélectionnez alors l'option « Je paie moi-même ».",
    it: "Paga di tasca sua? Allora selezioni l'opzione “Pago di tasca mia”.",
    sq: "A paguani vetë? Atëherë zgjidhni opsionin “Paguaj vetë”.",
  },
  APPOINTMENT_SELF_PAYER_DURATION_HEADLINE: {
    de: "Wie lange möchten Sie behandelt werden?",
    en: "How long would you like to be treated?",
    tr: "Ne kadar süre tedavi görmek istersiniz?",
    cs: "Jak dlouho chcete být ošetřováni?",
    ru: "Как долго вы хотите проходить лечение?",
    hr: "Koliko dugo želite biti tretirani?",
    es: "¿Cuánto tiempo desea ser tratado?",
    fr: "Combien de temps souhaitez-vous être traité ?",
    it: "Quanto a lungo desidera essere trattato?",
    sq: "Sa gjatë dëshironi të trajtoheni?",
  },
  APPOINTMENT_SELF_PAYER_DURATION_DESCRIPTION: {
    de: "Bitte wählen Sie die gewünschte Behandlungsdauer aus.",
    en: "Please choose your preferred treatment duration.",
    tr: "Lütfen istediğiniz tedavi süresini seçin.",
    cs: "Vyberte prosím požadovanou délku ošetření.",
    ru: "Пожалуйста, выберите желаемую продолжительность лечения.",
    hr: "Molimo odaberite željeno trajanje tretmana.",
    es: "Por favor, elija la duración de tratamiento deseada.",
    fr: "Veuillez choisir la durée de traitement souhaitée.",
    it: "Scelga la durata del trattamento desiderata.",
    sq: "Ju lutemi zgjidhni kohëzgjatjen e dëshiruar të trajtimit.",
  },
  APPOINTMENT_SELF_PAYER_ADDITIONAL_TREATMENTS_HEADLINE: {
    de: "Möchten Sie eine Zusatzbehandlung haben?",
    en: "Would you like an additional treatment?",
    tr: "Ek bir tedavi ister misiniz?",
    cs: "Přejete si doplňkové ošetření?",
    ru: "Хотите дополнительную процедуру?",
    hr: "Želite li dodatni tretman?",
    es: "¿Desea un tratamiento adicional?",
    fr: "Souhaitez-vous un traitement supplémentaire ?",
    it: "Desidera un trattamento aggiuntivo?",
    sq: "Dëshironi një trajtim shtesë?",
  },
  APPOINTMENT_SELF_PAYER_ADDITIONAL_TREATMENTS_DESCRIPTION: {
    de: "Wählen Sie optional Zusatzbehandlungen aus.",
    en: "Optionally select additional treatments.",
    tr: "İsteğe bağlı olarak ek tedaviler seçin.",
    cs: "Volitelně vyberte doplňková ošetření.",
    ru: "При желании выберите дополнительные процедуры.",
    hr: "Po želji odaberite dodatne tretmane.",
    es: "Opcionalmente, seleccione tratamientos adicionales.",
    fr: "Sélectionnez éventuellement des traitements supplémentaires.",
    it: "Facoltativamente selezioni trattamenti aggiuntivi.",
    sq: "Opsionalisht zgjidhni trajtime shtesë.",
  },
  APPOINTMENT_TIME_SLOTS_HEADLINE: {
    de: "Wunschzeiten wählen",
    en: "Choose your Preferred Times",
    tr: "Tercih Edilen Saatleri Seçin",
    cs: "Vyberte preferované časy",
    ru: "Выберите предпочтительное время",
    hr: "Odaberite preferirana vremena",
    es: "Elija sus horarios preferidos",
    fr: "Choisissez vos horaires préférés",
    it: "Scegli i tuoi orari preferiti",
    sq: "Zgjidhni oraret e preferuara",
  },
  APPOINTMENT_TIME_SLOTS_DESCRIPTION: {
    de: "Geben Sie bitte so viele Zeitfenster wie möglich an. Unser Empfang stimmt anschließend den Termin mit Ihnen ab.",
    en: "Please specify as many time slots as possible. Our reception will then coordinate the appointment with you.",
    tr: "Lütfen mümkün olduğunca çok zaman dilimi belirtin. Resepsiyonumuz daha sonra randevuyu sizinle koordine edecektir.",
    cs: "Uveďte prosím co nejvíce časových úseků. Naše recepce s vámi poté zkoordinuje termín.",
    ru: "Пожалуйста, укажите как можно больше временных интервалов. Наша рецепция согласует с вами время.",
    hr: "Navedite što više vremenskih termina. Naša recepcija će zatim dogovoriti termin s vama.",
    es: "Por favor especifique tantos horarios como sea posible. Nuestra recepción coordinará la cita con usted.",
    fr: "Veuillez indiquer autant de créneaux horaires que possible. Notre réception coordonnera ensuite le rendez-vous avec vous.",
    it: "Indica il maggior numero possibile di fasce orarie. La nostra reception coordinerà l'appuntamento con te.",
    sq: "Ju lutem specifikoni sa më shumë orare të mundshme. Recepsioni ynë do të koordinojë takimin me ju.",
  },
  APPOINTMENT_TIME_SLOTS_NOTES_PLACEHOLDER: {
    de: "Hinweistext",
    en: "Additional notes",
    tr: "Ek notlar",
    cs: "Další poznámky",
    ru: "Дополнительные примечания",
    hr: "Dodatne napomene",
    es: "Notas adicionales",
    fr: "Remarques supplémentaires",
    it: "Note aggiuntive",
    sq: "Shënime shtesë",
  },
  APPOINTMENT_PRACTICE_SELECTION_HEADLINE: {
    de: "Praxis auswählen",
    en: "Select Your Practice",
    tr: "Kliniğinizi Seçin",
    cs: "Vyberte svou praxi",
    ru: "Выберите клинику",
    hr: "Odaberite ordinaciju",
    es: "Seleccione su clínica",
    fr: "Sélectionnez votre cabinet",
    it: "Seleziona il tuo studio",
    sq: "Zgjidhni klinikën tuaj",
  },
  APPOINTMENT_PRACTICE_SELECTION_DESCRIPTION: {
    de: "Bitte wählen Sie einen Standort.",
    en: "At which practice would you like to make an appointment?",
    tr: "Hangi klinikte randevu almak istiyorsunuz?",
    cs: "Na které praxi byste se chtěli objednat?",
    ru: "В какой клинике вы хотели бы записаться на прием?",
    hr: "U kojoj ordinaciji želite zakazati termin?",
    es: "¿En qué clínica le gustaría pedir cita?",
    fr: "Dans quel cabinet souhaitez-vous prendre rendez-vous ?",
    it: "In quale studio vorresti prendere appuntamento?",
    sq: "Në cilën klinikë dëshironi të bëni termin?",
  },
  APPOINTMENT_DEPARTMENT_SELECTION_HEADLINE: {
    de: "Heilmittelbereich wählen",
    en: "Select Treatment Area",
    tr: "Tedavi Alanını Seçin",
    cs: "Vyberte oblast terapie",
    ru: "Выберите направление лечения",
    hr: "Odaberite područje terapije",
    es: "Seleccione el área de tratamiento",
    fr: "Sélectionnez le domaine de traitement",
    it: "Seleziona l'area di trattamento",
    sq: "Zgjidhni fushën e trajtimit",
  },
  APPOINTMENT_DEPARTMENT_SELECTION_DESCRIPTION: {
    de: "Wählen Sie den Bereich, zu dem Ihr Anliegen gehört.",
    en: "Select the area your concern belongs to.",
    tr: "Talebinizin ait olduğu alanı seçin.",
    cs: "Vyberte oblast, do které váš požadavek patří.",
    ru: "Выберите направление, к которому относится ваш запрос.",
    hr: "Odaberite područje kojem pripada vaš zahtjev.",
    es: "Seleccione el área a la que pertenece su solicitud.",
    fr: "Sélectionnez le domaine auquel votre demande appartient.",
    it: "Seleziona l'area a cui appartiene la tua richiesta.",
    sq: "Zgjidhni fushën së cilës i përket kërkesa juaj.",
  },
  THERAPY_DEPARTMENT_PHYSIOTHERAPY: {
    de: "Physiotherapie",
    en: "Physiotherapy",
    tr: "Fizyoterapi",
    cs: "Fyzioterapie",
    ru: "Физиотерапия",
    hr: "Fizioterapija",
    es: "Fisioterapia",
    fr: "Physiothérapie",
    it: "Fisioterapia",
    sq: "Fizioterapi",
  },
  THERAPY_DEPARTMENT_OCCUPATIONAL_THERAPY: {
    de: "Ergotherapie",
    en: "Occupational Therapy",
    tr: "Ergoterapi",
    cs: "Ergoterapie",
    ru: "Эрготерапия",
    hr: "Radna terapija",
    es: "Terapia ocupacional",
    fr: "Ergothérapie",
    it: "Terapia occupazionale",
    sq: "Terapi okupacionale",
  },
  THERAPY_DEPARTMENT_OSTEOPATHY: {
    de: "Osteopathie",
    en: "Osteopathy",
    tr: "Osteopati",
    cs: "Osteopatie",
    ru: "Остеопатия",
    hr: "Osteopatija",
    es: "Osteopatía",
    fr: "Ostéopathie",
    it: "Osteopatia",
    sq: "Osteopati",
  },
  THERAPY_DEPARTMENT_SPEECH_THERAPY: {
    de: "Logopädie",
    en: "Speech Therapy",
    tr: "Konuşma Terapisi",
    cs: "Logopedie",
    ru: "Логопедия",
    hr: "Logopedija",
    es: "Logopedia",
    fr: "Orthophonie",
    it: "Logopedia",
    sq: "Logopedi",
  },
  THERAPY_DEPARTMENT_PODOLOGY: {
    de: "Podologie",
    en: "Podiatry",
    tr: "Podoloji",
    cs: "Podologie",
    ru: "Подология",
    hr: "Podologija",
    es: "Podología",
    fr: "Podologie",
    it: "Podologia",
    sq: "Podologji",
  },
  THERAPY_DEPARTMENT_NUTRITION_THERAPY: {
    de: "Ernährungstherapie",
    en: "Nutrition Therapy",
    tr: "Beslenme Terapisi",
    cs: "Výživová terapie",
    ru: "Диетотерапия",
    hr: "Nutricionistička terapija",
    es: "Terapia nutricional",
    fr: "Thérapie nutritionnelle",
    it: "Terapia nutrizionale",
    sq: "Terapi ushqyese",
  },
  THERAPY_DEPARTMENT_TRAINING_THERAPY: {
    de: "Trainingstherapie",
    en: "Training Therapy",
    tr: "Antrenman Terapisi",
    cs: "Tréninková terapie",
    ru: "Тренировочная терапия",
    hr: "Terapija treningom",
    es: "Terapia de entrenamiento",
    fr: "Thérapie d'entraînement",
    it: "Terapia di allenamento",
    sq: "Terapi stërvitjeje",
  },
  APPOINTMENT_SUCCESS_HEADLINE: {
    de: "Anfrage erfolgreich",
    en: "Thank You",
    tr: "Teşekkür Ederiz",
    cs: "Děkujeme",
    ru: "Спасибо",
    hr: "Hvala",
    es: "Gracias",
    fr: "Merci",
    it: "Grazie",
    sq: "Faleminderit",
  },
  APPOINTMENT_SUCCESS_DESCRIPTION: {
    de: "Wir verarbeiten Ihre Daten und kümmern uns zeitnah um Ihre Anfrage. Unser Team meldet sich so schnell wie möglich bei Ihnen zurück.",
    en: "We are processing your data and will take care of your appointment request promptly. Our team will get back to you as quickly as possible – we look forward to welcoming you in person soon.",
    tr: "Verilerinizi işliyoruz ve randevu talebinizle hemen ilgileniyoruz. Ekibimiz en kısa sürede size geri dönüş yapacak – sizi yakında şahsen karşılamayı dört gözle bekliyoruz.",
    cs: "Zpracováváme vaše údaje a vaši žádost o schůzku vyřídíme neprodleně. Náš tým se vám ozve co nejdříve – těšíme se na brzkou osobní návštěvu.",
    ru: "Мы обрабатываем ваши данные и оперативно рассмотрим ваш запрос на прием. Наша команда свяжется с вами как можно скорее – мы с нетерпением ждем встречи с вами в ближайшее время.",
    hr: "Obrađujemo vaše podatke i brzo ćemo se pobrinuti za vaš zahtjev za terminom. Naš tim će vam se javiti što je prije moguće – radujemo se što ćemo vas uskoro osobno pozdraviti.",
    es: "Estamos procesando sus datos y atenderemos su solicitud de cita con prontitud. Nuestro equipo se pondrá en contacto con usted lo antes posible; esperamos darle la bienvenida en persona pronto.",
    fr: "Nous traitons vos données et nous occuperons rapidement de votre demande de rendez-vous. Notre équipe vous recontactera dès que possible – nous avons hâte de vous accueillir bientôt en personne.",
    it: "Stiamo elaborando i tuoi dati e ci occuperemo prontamente della tua richiesta di appuntamento. Il nostro team ti ricontatterà il prima possibile – non vediamo l'ora di accoglierti di persona presto.",
    sq: "Po përpunojmë të dhënat tuaja dhe do të kujdesemi për kërkesën tuaj për takim menjëherë. Ekipi ynë do t'ju kontaktojë sa më shpejt të jetë e mundur – presim me padurim t'ju mirëpresim personalisht së shpejti.",
  },
  MEDIA_UPLOAD_SUPPORTED_FORMATS: {
    de: "Unterstützte Dateiformate:",
    en: "Supported file formats:",
    tr: "Desteklenen dosya formatları:",
    cs: "Podporované formáty souborů:",
    ru: "Поддерживаемые форматы файлов:",
    hr: "Podržani formati datoteka:",
    es: "Formatos de archivo admitidos:",
    fr: "Formats de fichiers pris en charge :",
    it: "Formati file supportati:",
    sq: "Formatet e mbështetura të skedarëve:",
  },
  MEDIA_UPLOAD_MAX_FILE_SIZE: {
    de: "Maximale Dateigröße:",
    en: "Maximum file size:",
    tr: "Maksimum dosya boyutu:",
    cs: "Maximální velikost souboru:",
    ru: "Максимальный размер файла:",
    hr: "Maksimalna veličina datoteke:",
    es: "Tamaño máximo de archivo:",
    fr: "Taille maximale du fichier :",
    it: "Dimensione massima file:",
    sq: "Madhësia maksimale e skedarit:",
  },
  MEDIA_UPLOAD_DRAG_DROP_OR: {
    de: "Drag and Drop oder ",
    en: "Drag and Drop or ",
    tr: "Sürükle bırak veya ",
    cs: "Drag and Drop nebo ",
    ru: "Перетащите или ",
    hr: "Povuci i ispusti ili ",
    es: "Arrastrar y soltar o ",
    fr: "Glisser-déposer ou ",
    it: "Trascina e rilascia o ",
    sq: "Zvarrit dhe lësho ose ",
  },
  MEDIA_UPLOAD_SELECT_FILE: {
    de: "Datei auswählen",
    en: "Select file",
    tr: "Dosya seç",
    cs: "Vybrat soubor",
    ru: "Выбрать файл",
    hr: "Odaberi datoteku",
    es: "Seleccionar archivo",
    fr: "Sélectionner un fichier",
    it: "Seleziona file",
    sq: "Zgjidh skedarin",
  },
  MEDIA_UPLOAD_MULTIPLE_FILES: {
    de: "Sie können mehrere Dateien gleichzeitig hochladen",
    en: "You can upload multiple files at once",
    tr: "Aynı anda birden fazla dosya yükleyebilirsiniz",
    cs: "Můžete nahrát více souborů najednou",
    ru: "Вы можете загрузить несколько файлов одновременно",
    hr: "Možete učitati više datoteka odjednom",
    es: "Puede subir varios archivos a la vez",
    fr: "Vous pouvez télécharger plusieurs fichiers à la fois",
    it: "Puoi caricare più file contemporaneamente",
    sq: "Mund të ngarkoni disa skedarë njëherësh",
  },
  APPOINTMENT_ERROR_HEADLINE: {
    de: "Leider kann aktuell kein Termin angefragt werden",
    en: "Unfortunately, no appointment can be requested at the moment",
    tr: "Maalesef şu anda randevu talep edilemiyor",
    cs: "Bohužel momentálně nelze požádat o schůzku",
    ru: "К сожалению, в данный момент записаться на прием невозможно",
    hr: "Nažalost, trenutno nije moguće zatražiti termin",
    es: "Desafortunadamente, no se puede solicitar una cita en este momento",
    fr: "Malheureusement, aucun rendez-vous ne peut être demandé pour le moment",
    it: "Purtroppo, al momento non è possibile richiedere un appuntamento",
    sq: "Për fat të keq, nuk mund të kërkohet takim për momentin",
  },
  APPOINTMENT_ERROR_DESCRIPTION: {
    de: "Terminanfragen sind derzeit nur mit Rezept möglich.\n Als Selbstzahler wählen Sie bitte vorab „Ich bin Selbstzahler“.",
    en: "Appointment requests are currently only possible with a prescription.\n If you are a self-payer, please select “I am a self-payer” in advance.",
    tr: "Randevu talepleri şu anda yalnızca reçete ile mümkündür.\n Eğer kendiniz ödeyen biriyseniz, lütfen önceden “Masrafları kendim karşılıyorum” seçeneğini seçin.",
    cs: "Žádosti o schůzku jsou momentálně možné pouze s receptem.\n Pokud jste samoplátce, vyberte prosím předem „Jsem samoplátce“.",
    ru: "Запросы на прием в настоящее время возможны только с рецептом.\n Если вы оплачиваете самостоятельно, пожалуйста, выберите «Я оплачиваю самостоятельно» заранее.",
    hr: "Zahtjevi za termin su trenutno mogući samo s receptom.\n Ako ste samoplaćatelj, molimo odaberite „Sam plaćam“ unaprijed.",
    es: "Las solicitudes de cita actualmente solo son posibles con una receta.\n Si usted es un pagador propio, por favor seleccione “Soy pagador propio” con anticipación.",
    fr: "Les demandes de rendez-vous sont actuellement possibles uniquement avec une ordonnance.\n Si vous êtes un payeur autonome, veuillez sélectionner « Je paie moi-même » à l'avance.",
    it: "Le richieste di appuntamento sono attualmente possibili solo con una prescrizione.\n Se sei un pagatore autonomo, seleziona “Pago di tasca mia” in anticipo.",
    sq: "Kërkesat për takim janë aktualisht të mundshme vetëm me një recetë.\n Nëse jeni një pagues i pavarur, ju lutem zgjidhni “Paguaj vetë” paraprakisht.",
  },
  APPOINTMENT_UNAVAILABLE_HEADLINE: {
    de: "Online-Terminanfrage nicht verfügbar",
    en: "Online appointment requests unavailable",
    tr: "Online randevu talebi kullanılamıyor",
    cs: "Online rezervace termínů není dostupná",
    ru: "Онлайн-запись недоступна",
    hr: "Online zahtjev za termin nije dostupan",
    es: "Solicitud de cita online no disponible",
    fr: "Demande de rendez-vous en ligne indisponible",
    it: "Richiesta di appuntamento online non disponibile",
    sq: "Kërkesa online për termin nuk është e disponueshme",
  },
  APPOINTMENT_UNAVAILABLE_DESCRIPTION: {
    de: "Für diese Praxis ist die Online-Terminanfrage derzeit nicht verfügbar.\n Bitte kontaktieren Sie Ihre Praxis direkt, um einen Termin zu vereinbaren.",
    en: "Online appointment requests are currently unavailable for this practice.\n Please contact your practice directly to arrange an appointment.",
    tr: "Bu klinik için online randevu talebi şu anda kullanılamıyor.\n Randevu almak için lütfen doğrudan kliniğinizle iletişime geçin.",
    cs: "Pro tuto praxi není online rezervace termínů momentálně dostupná.\n Pro sjednání termínu prosím kontaktujte svou praxi přímo.",
    ru: "Онлайн-запись на прием в этой клинике в настоящее время недоступна.\n Пожалуйста, свяжитесь с вашей клиникой напрямую, чтобы записаться на прием.",
    hr: "Za ovu ordinaciju online zahtjev za termin trenutno nije dostupan.\n Molimo kontaktirajte svoju ordinaciju izravno kako biste zakazali termin.",
    es: "La solicitud de cita online no está disponible actualmente para esta clínica.\n Por favor, póngase en contacto directamente con su clínica para concertar una cita.",
    fr: "La demande de rendez-vous en ligne n'est actuellement pas disponible pour ce cabinet.\n Veuillez contacter directement votre cabinet pour convenir d'un rendez-vous.",
    it: "La richiesta di appuntamento online non è attualmente disponibile per questo studio.\n Contatta direttamente il tuo studio per fissare un appuntamento.",
    sq: "Për këtë klinikë kërkesa online për termin aktualisht nuk është e disponueshme.\n Ju lutem kontaktoni klinikën tuaj drejtpërdrejt për të caktuar një termin.",
  },
  APPOINTMENT_UNAVAILABLE_DESCRIPTION_PRACTICE: {
    de: "Für {{practiceName}} ist die Online-Terminanfrage derzeit nicht verfügbar.\n Bitte kontaktieren Sie Ihre Praxis direkt, um einen Termin zu vereinbaren.",
    en: "Online appointment requests are currently unavailable for {{practiceName}}.\n Please contact your practice directly to arrange an appointment.",
    tr: "{{practiceName}} için online randevu talebi şu anda kullanılamıyor.\n Randevu almak için lütfen doğrudan kliniğinizle iletişime geçin.",
    cs: "Pro {{practiceName}} není online rezervace termínů momentálně dostupná.\n Pro sjednání termínu prosím kontaktujte svou praxi přímo.",
    ru: "Онлайн-запись на прием в {{practiceName}} в настоящее время недоступна.\n Пожалуйста, свяжитесь с вашей клиникой напрямую, чтобы записаться на прием.",
    hr: "Za {{practiceName}} online zahtjev za termin trenutno nije dostupan.\n Molimo kontaktirajte svoju ordinaciju izravno kako biste zakazali termin.",
    es: "La solicitud de cita online no está disponible actualmente para {{practiceName}}.\n Por favor, póngase en contacto directamente con su clínica para concertar una cita.",
    fr: "La demande de rendez-vous en ligne n'est actuellement pas disponible pour {{practiceName}}.\n Veuillez contacter directement votre cabinet pour convenir d'un rendez-vous.",
    it: "La richiesta di appuntamento online non è attualmente disponibile per {{practiceName}}.\n Contatta direttamente il tuo studio per fissare un appuntamento.",
    sq: "Për {{practiceName}} kërkesa online për termin aktualisht nuk është e disponueshme.\n Ju lutem kontaktoni klinikën tuaj drejtpërdrejt për të caktuar një termin.",
  },
  APPOINTMENT_ACTION_TYPE_BOOKING_TITLE: {
    de: "Termin vereinbaren",
    en: "Book Appointment",
    tr: "Randevu Al",
    cs: "Rezervovat termín",
    ru: "Записаться на прием",
    hr: "Rezerviraj termin",
    es: "Reservar cita",
    fr: "Prendre rendez-vous",
    it: "Prenota appuntamento",
    sq: "Rezervo termin",
  },
  APPOINTMENT_ACTION_TYPE_CANCELLATION_TITLE: {
    de: "Termin absagen",
    en: "Cancel Appointment",
    tr: "Randevu İptal Et",
    cs: "Zrušit termín",
    ru: "Отменить запись",
    hr: "Otkaži termin",
    es: "Cancelar cita",
    fr: "Annuler rendez-vous",
    it: "Annulla appuntamento",
    sq: "Anulo terminin",
  },
  APPOINTMENT_ACTION_TYPE_RESCHEDULING_TITLE: {
    de: "Termin verschieben",
    en: "Reschedule Appointment",
    tr: "Randevu Ertele",
    cs: "Přeložit termín",
    ru: "Перенести запись",
    hr: "Promijeni termin",
    es: "Reprogramar cita",
    fr: "Reporter rendez-vous",
    it: "Riprogramma appuntamento",
    sq: "Shty terminin",
  },
  APPOINTMENT_ACTION_TYPE_SCREEN_TITLE: {
    de: "Anliegen wählen",
    en: "Select Request Type",
    tr: "Talep Türünü Seçin",
    cs: "Vyberte typ požadavku",
    ru: "Выберите тип запроса",
    hr: "Odaberite vrstu zahtjeva",
    es: "Seleccione tipo de solicitud",
    fr: "Sélectionnez le type de demande",
    it: "Seleziona tipo richiesta",
    sq: "Zgjidhni llojin e kërkesës",
  },
  APPOINTMENT_OPENING_INFO_HEADLINE: {
    de: "NEUERÖFFNUNG AB SEPTEMBER",
    en: "GRAND OPENING FROM SEPTEMBER",
    tr: "EYLÜL'DEN İTİBAREN YENİ AÇILIŞ",
    cs: "NOVÉ OTEVŘENÍ OD ZÁŘÍ",
    ru: "ОТКРЫТИЕ В СЕНТЯБРЕ",
    hr: "SVEČANO OTVARANJE OD RUJNA",
    es: "GRAN APERTURA DESDE SEPTIEMBRE",
    fr: "GRANDE OUVERTURE À PARTIR DE SEPTEMBRE",
    it: "GRANDE APERTURA DA SETTEMBRE",
    sq: "HAPJA E RE NGA SHTATORI",
  },
  APPOINTMENT_OPENING_INFO_TEXT: {
    de: "Sichern Sie sich jetzt bereits Ihre Termine.",
    en: "Secure your appointments now.",
    tr: "Şimdi randevularınızı ayırtın.",
    cs: "Zajistěte si termíny již nyní.",
    ru: "Запишитесь на приём уже сейчас.",
    hr: "Osigurajte si termine već sada.",
    es: "Asegure sus citas ahora.",
    fr: "Réservez dès maintenant vos rendez-vous.",
    it: "Prenota i tuoi appuntamenti ora.",
    sq: "Siguroni takimet tuaja tani.",
  },
  APPOINTMENT_PHONE_NUMBER_SCREEN_TITLE: {
    de: "Handynummer eingeben",
    en: "Enter Mobile Number",
    tr: "Cep Telefonu Numarası Girin",
    cs: "Zadejte mobilní číslo",
    ru: "Введите номер мобильного",
    hr: "Unesite broj mobitela",
    es: "Ingrese número de móvil",
    fr: "Entrez le numéro de mobile",
    it: "Inserisci numero cellulare",
    sq: "Shkruani numrin celular",
  },
  APPOINTMENT_PHONE_NUMBER_SCREEN_DESCRIPTION: {
    de: "Bitte geben Sie hier Ihre Handynummer ein. Wir nutzen sie zur sicheren Identifizierung.",
    en: "Please enter your mobile number here. We use it for secure identification.",
    tr: "Lütfen cep telefonu numaranızı buraya girin. Güvenli kimlik doğrulama için kullanıyoruz.",
    cs: "Zadejte zde své mobilní číslo. Používáme ho pro bezpečnou identifikaci.",
    ru: "Пожалуйста, введите здесь свой номер мобильного. Мы используем его для безопасной идентификации.",
    hr: "Ovdje unesite svoj broj mobitela. Koristimo ga za sigurnu identifikaciju.",
    es: "Por favor ingrese su número de móvil aquí. Lo usamos para identificación segura.",
    fr: "Veuillez entrer votre numéro de mobile ici. Nous l'utilisons pour une identification sécurisée.",
    it: "Inserisci qui il tuo numero di cellulare. Lo usiamo per l'identificazione sicura.",
    sq: "Ju lutem shkruani numrin tuaj celular këtu. E përdorim për identifikim të sigurt.",
  },
  APPOINTMENT_PHONE_NUMBER_CONFIRMATION_TITLE: {
    de: "Handynummer bestätigen",
    en: "Confirm Mobile Number",
    tr: "Cep Telefonu Numarasını Onaylayın",
    cs: "Potvrdit mobilní číslo",
    ru: "Подтвердить номер",
    hr: "Potvrdi broj mobitela",
    es: "Confirmar número de móvil",
    fr: "Confirmer le numéro",
    it: "Conferma numero",
    sq: "Konfirmo numrin celular",
  },
  APPOINTMENT_PHONE_NUMBER_CONFIRMATION_DESCRIPTION: {
    de: "Wir haben Ihnen einen 6-stelligen Code per SMS an +491797272437 gesendet. Es kann bis zu 2 min dauern, bis er ankommt.",
    en: "We have sent you a 6-digit code via SMS to +491797272437. It may take up to 2 minutes to arrive.",
    tr: "Size +491797272437 numarasına SMS ile 6 haneli bir kod gönderdik. Ulaşması 2 dakikaya kadar sürebilir.",
    cs: "Poslali jsme vám 6místný kód SMS na číslo +491797272437. Může to trvat až 2 minuty.",
    ru: "Мы отправили вам 6-значный код по SMS на +491797272437. Это может занять до 2 минут.",
    hr: "Poslali smo vam 6-znamenkasti kod SMS-om na +491797272437. Može potrajati do 2 minute.",
    es: "Le hemos enviado un código de 6 dígitos por SMS al +491797272437. Puede tardar hasta 2 minutos.",
    fr: "Nous vous avons envoyé un code à 6 chiffres par SMS au +491797272437. Cela peut prendre jusqu'à 2 minutes.",
    it: "Ti abbiamo inviato un codice a 6 cifre via SMS al +491797272437. Potrebbero volerci fino a 2 minuti.",
    sq: "Ju kemi dërguar një kod 6-shifror me SMS në +491797272437. Mund të marrë deri në 2 minuta.",
  },
  APPOINTMENT_PHONE_NUMBER_RESEND_CODE: {
    de: "Code erneut senden",
    en: "Resend code",
    tr: "Kodu yeniden gönder",
    cs: "Znovu odeslat kód",
    ru: "Отправить код снова",
    hr: "Pošalji kod ponovo",
    es: "Reenviar código",
    fr: "Renvoyer le code",
    it: "Reinvia codice",
    sq: "Ri-dërgo kodin",
  },
  APPOINTMENT_PHONE_VERIFICATION_INVALID_CODE_ERROR: {
    de: "Ungültiger Code. Bitte versuchen Sie es erneut.",
    en: "Invalid code. Please try again.",
    tr: "Geçersiz kod. Lütfen tekrar deneyin.",
    cs: "Neplatný kód. Zkuste to prosím znovu.",
    ru: "Неверный код. Пожалуйста, попробуйте снова.",
    hr: "Nevažeći kod. Molimo pokušajte ponovo.",
    es: "Código inválido. Por favor intente de nuevo.",
    fr: "Code invalide. Veuillez réessayer.",
    it: "Codice non valido. Riprova.",
    sq: "Kod i pavlefshëm. Ju lutem provoni përsëri.",
  },
  APPOINTMENT_CANCELLATION_SCREEN_TITLE: {
    de: "Termin absagen",
    en: "Cancel Appointment",
    tr: "Randevuyu İptal Et",
    cs: "Zrušit termín",
    ru: "Отменить запись",
    hr: "Otkaži termin",
    es: "Cancelar cita",
    fr: "Annuler le rendez-vous",
    it: "Annulla appuntamento",
    sq: "Anulo terminin",
  },
  APPOINTMENT_RESCHEDULING_SCREEN_TITLE: {
    de: "Termin verschieben",
    en: "Reschedule Appointment",
    tr: "Randevuyu Ertele",
    cs: "Přeložit termín",
    ru: "Перенести запись",
    hr: "Promijeni termin",
    es: "Reprogramar cita",
    fr: "Reporter le rendez-vous",
    it: "Riprogramma appuntamento",
    sq: "Shty terminin",
  },
  APPOINTMENT_CANCELLATION_SCREEN_DESCRIPTION: {
    de: "Wann hätten Sie Ihren Termin gehabt? Bitte teilen Sie uns Datum und Uhrzeit mit.",
    en: "When was your appointment scheduled? Please provide us with the date and time.",
    tr: "Randevunuz ne zaman olacaktı? Lütfen tarih ve saati bizimle paylaşın.",
    cs: "Kdy jste měl(a) termín? Sdělte nám prosím datum a čas.",
    ru: "Когда у вас был назначен прием? Пожалуйста, сообщите нам дату и время.",
    hr: "Kada ste imali termin? Molimo vas da nam date datum i vrijeme.",
    es: "¿Cuándo tenía su cita? Por favor proporciónenos la fecha y la hora.",
    fr: "Quand votre rendez-vous était-il prévu ? Veuillez nous indiquer la date et l'heure.",
    it: "Quando era fissato il tuo appuntamento? Forniscici data e ora.",
    sq: "Kur ishte caktuar takimi juaj? Ju lutem na jepni datën dhe orën.",
  },
  APPOINTMENT_SHORT_NOTICE_CONFIRMATION: {
    de: "Ich habe zur Kenntnis genommen, dass bei einer Absage oder Verschiebung des Termins weniger als 24 Stunden vor dem Termin ein Ausfallhonorar berechnet werden kann.",
    en: "I acknowledge that a cancellation fee may be charged if the appointment is cancelled or rescheduled less than 24 hours before it takes place.",
    tr: "Randevunun 24 saatten daha kısa bir süre kala iptal edilmesi veya ertelenmesi durumunda iptal ücreti talep edilebileceğini bildiğimi onaylıyorum.",
    cs: "Beru na vědomí, že při zrušení nebo přesunutí termínu méně než 24 hodin předem může být účtován storno poplatek.",
    ru: "Я принимаю к сведению, что при отмене или переносе приёма менее чем за 24 часа до его начала может взиматься плата за отмену.",
    hr: "Primam na znanje da se u slučaju otkazivanja ili pomicanja termina manje od 24 sata unaprijed može naplatiti naknada za otkazivanje.",
    es: "Soy consciente de que, si la cita se cancela o se cambia con menos de 24 horas de antelación, se puede cobrar una tarifa de cancelación.",
    fr: "J'ai pris connaissance du fait qu'en cas d'annulation ou de report du rendez-vous moins de 24 heures à l'avance, des frais d'annulation peuvent être facturés.",
    it: "Prendo atto che, in caso di annullamento o spostamento dell'appuntamento meno di 24 ore prima, può essere addebitata una penale.",
    sq: "Jam në dijeni se në rast anulimi ose shtyrjeje të takimit më pak se 24 orë përpara, mund të tarifohet një tarifë anulimi.",
  },
  APPOINTMENT_CANCELLATION_SCREEN_DATE_LABEL: {
    de: "Datum & Uhrzeit",
    en: "Date & Time",
    tr: "Tarih & Saat",
    cs: "Datum a čas",
    ru: "Дата и время",
    hr: "Datum i vrijeme",
    es: "Fecha y hora",
    fr: "Date et heure",
    it: "Data e ora",
    sq: "Data dhe ora",
  },
  APPOINTMENT_CANCELLATION_REQUEST_SUCCESS_TITLE: {
    de: "Anfrage erfolgreich",
    en: "Request Successful",
    tr: "Talep Başarılı",
    cs: "Žádost úspěšná",
    ru: "Запрос успешен",
    hr: "Zahtjev uspješan",
    es: "Solicitud exitosa",
    fr: "Demande réussie",
    it: "Richiesta riuscita",
    sq: "Kërkesa e suksesshme",
  },
  APPOINTMENT_CANCELLATION_REQUEST_SUCCESS_DESCRIPTION: {
    de: "Wir verarbeiten Ihre Daten und kümmern uns zeitnah um Ihre Anfrage. Unser Team meldet sich so schnell wie möglich bei Ihnen zurück.",
    en: "We are processing your data and will take care of your request promptly. Our team will get back to you as quickly as possible.",
    tr: "Verilerinizi işliyoruz ve talebinizle hemen ilgileniyoruz. Ekibimiz en kısa sürede size geri dönüş yapacak.",
    cs: "Zpracováváme vaše údaje a vaši žádost vyřídíme neprodleně. Náš tým se vám ozve co nejdříve.",
    ru: "Мы обрабатываем ваши данные и оперативно рассмотрим ваш запрос. Наша команда свяжется с вами как можно скорее.",
    hr: "Obrađujemo vaše podatke i brzo ćemo se pobrinuti za vaš zahtjev. Naš tim će vam se javiti što je prije moguće.",
    es: "Estamos procesando sus datos y atenderemos su solicitud con prontitud. Nuestro equipo se pondrá en contacto con usted lo antes posible.",
    fr: "Nous traitons vos données et nous occuperons rapidement de votre demande. Notre équipe vous recontactera dès que possible.",
    it: "Stiamo elaborando i tuoi dati e ci occuperemo prontamente della tua richiesta. Il nostro team ti ricontatterà il prima possibile.",
    sq: "Po përpunojmë të dhënat tuaja dhe do të kujdesemi për kërkesën tuaj menjëherë. Ekipi ynë do t'ju kontaktojë sa më shpejt të jetë e mundur.",
  },
  APPOINTMENT_CANCELLATION_REQUEST_CTA: {
    de: "Zurück zur Website",
    en: "Back to Website",
    tr: "Web sitesine geri dön",
    cs: "Zpět na web",
    ru: "Вернуться на сайт",
    hr: "Natrag na web stranicu",
    es: "Volver al sitio web",
    fr: "Retour au site web",
    it: "Torna al sito web",
    sq: "Kthehu në faqen e internetit",
  },
  SIDE_BAR_CHOOSE_REQUEST_TYPE_LABEL: {
    de: "Anliegen wählen",
    en: "Select Request Type",
    tr: "Talep Türünü Seçin",
    cs: "Vyberte typ požadavku",
    ru: "Выберите тип запроса",
    hr: "Odaberite vrstu zahtjeva",
    es: "Seleccione tipo de solicitud",
    fr: "Sélectionnez le type de demande",
    it: "Seleziona tipo richiesta",
    sq: "Zgjidhni llojin e kërkesës",
  },
  SIDE_BAR_CHOOSE_PRACTICE_LABEL: {
    de: "Praxis auswählen",
    en: "Select Practice",
    tr: "Kliniğinizi Seçin",
    cs: "Vyberte praxi",
    ru: "Выберите клинику",
    hr: "Odaberite ordinaciju",
    es: "Seleccione práctica",
    fr: "Sélectionnez le cabinet",
    it: "Seleziona studio",
    sq: "Zgjidhni klinikën",
  },
  SIDE_BAR_CHOOSE_DEPARTMENT_LABEL: {
    de: "Heilmittelbereich",
    en: "Treatment Area",
    tr: "Tedavi Alanı",
    cs: "Oblast terapie",
    ru: "Направление лечения",
    hr: "Područje terapije",
    es: "Área de tratamiento",
    fr: "Domaine de traitement",
    it: "Area di trattamento",
    sq: "Fusha e trajtimit",
  },
  SIDE_BAR_RECIPE_UPLOAD_LABEL: {
    de: "Rezept hochladen",
    en: "Upload Prescription",
    tr: "Reçete Yükle",
    cs: "Nahrát recept",
    ru: "Загрузить рецепт",
    hr: "Učitaj recept",
    es: "Subir receta",
    fr: "Télécharger l'ordonnance",
    it: "Carica ricetta",
    sq: "Ngarko recetën",
  },
  SIDE_BAR_TIME_SLOT_SELECTION_LABEL: {
    de: "Wunschzeiten wählen",
    en: "Choose Preferred Times",
    tr: "Tercih Edilen Saatleri Seçin",
    cs: "Vyberte preferované časy",
    ru: "Выберите предпочтительное время",
    hr: "Odaberite preferirana vremena",
    es: "Elija horarios preferidos",
    fr: "Choisissez les horaires préférés",
    it: "Scegli orari preferiti",
    sq: "Zgjidhni oraret e preferuara",
  },
  SIDE_BAR_CONTACT_INFORMATION_LABEL: {
    de: "Kontaktdaten eingeben",
    en: "Enter Contact Information",
    tr: "İletişim Bilgilerini Girin",
    cs: "Zadejte kontaktní údaje",
    ru: "Введите контактную информацию",
    hr: "Unesite kontakt podatke",
    es: "Ingrese información de contacto",
    fr: "Entrez les coordonnées",
    it: "Inserisci dati contatto",
    sq: "Shkruani të dhënat e kontaktit",
  },
  SIDE_BAR_REQUEST_SENT_LABEL: {
    de: "Anfrage gesendet",
    en: "Request Sent",
    tr: "Talep Gönderildi",
    cs: "Žádost odeslána",
    ru: "Запрос отправлен",
    hr: "Zahtjev poslan",
    es: "Solicitud enviada",
    fr: "Demande envoyée",
    it: "Richiesta inviata",
    sq: "Kërkesa u dërgua",
  },
  SIDE_BAR_PHONE_NUMBER_INPUT_LABEL: {
    de: "Handynummer eingeben",
    en: "Enter Mobile Number",
    tr: "Cep Telefonu Numarası Girin",
    cs: "Zadejte mobilní číslo",
    ru: "Введите номер мобильного",
    hr: "Unesite broj mobitela",
    es: "Ingrese número de móvil",
    fr: "Entrez le numéro de mobile",
    it: "Inserisci numero cellulare",
    sq: "Shkruani numrin celular",
  },
  SIDE_BAR_APPOINTMENT_INFORMATION_LABEL: {
    de: "Details zum Termin angeben",
    en: "Provide Appointment Details",
    tr: "Randevu Bilgileri",
    cs: "Uveďte podrobnosti o schůzce",
    ru: "Укажите детали приема",
    hr: "Navedite detalje termina",
    es: "Proporcione detalles de la cita",
    fr: "Fournir les détails du rendez-vous",
    it: "Fornisci dettagli appuntamento",
    sq: "Jepni detajet e takimit",
  },
  CHECK_IN_START: {
    de: "Jetzt einchecken",
    en: "Check-In Now",
    tr: "Şimdi giriş yapt",
    cs: "Odbavit se nyní",
    ru: "Зарегистрироваться сейчас",
    hr: "Prijavite se sada",
    es: "Registrarse ahora",
    fr: "S'enregistrer maintenant",
    it: "Check-in ora",
    sq: "Regjistrohuni tani",
  },
  FOOTER_TEXT_1: {
    de: "Powered by",
    en: "Powered by",
    tr: "Tarafından desteklenmektedir",
    cs: "Poháněno",
    ru: "При поддержке",
    hr: "Omogućuje",
    es: "Desarrollado por",
    fr: "Propulsé par",
    it: "Realizzato da",
    sq: "Mundësuar nga",
  },
  FOOTER_TEXT_2: {
    de: "Datenschutz",
    en: "Privacy Policy",
    tr: "Gizlilik Politikası",
    cs: "Ochrana osobních údajů",
    ru: "Политика конфиденциальности",
    hr: "Politika privatnosti",
    es: "Política de privacidad",
    fr: "Politique de confidentialité",
    it: "Politica sulla privacy",
    sq: "Politika e privatësisë",
  },
  PRIVACY_LINE: {
    de: "Es gilt die <privacyPolicyUrl>Datenschutzerklärung<privacyPolicyUrl> der Physiofit Digital GmbH.",
    en: "The <privacyPolicyUrl>privacy policy<privacyPolicyUrl> of Physiofit Digital GmbH applies.",
    tr: "Physiofit Digital GmbH'nin <privacyPolicyUrl>gizlilik politikası<privacyPolicyUrl> geçerlidir.",
    cs: "Platí <privacyPolicyUrl>zásady ochrany osobních údajů<privacyPolicyUrl> společnosti Physiofit Digital GmbH.",
    ru: "Действует <privacyPolicyUrl>политика конфиденциальности<privacyPolicyUrl> компании Physiofit Digital GmbH.",
    hr: "Primjenjuju se <privacyPolicyUrl>pravila privatnosti<privacyPolicyUrl> tvrtke Physiofit Digital GmbH.",
    es: "Se aplica la <privacyPolicyUrl>política de privacidad<privacyPolicyUrl> de Physiofit Digital GmbH.",
    fr: "La <privacyPolicyUrl>politique de confidentialité<privacyPolicyUrl> de Physiofit Digital GmbH s'applique.",
    it: "Si applica la <privacyPolicyUrl>politica sulla privacy<privacyPolicyUrl> di Physiofit Digital GmbH.",
    sq: "Zbatohet <privacyPolicyUrl>politika e privatësisë<privacyPolicyUrl> e Physiofit Digital GmbH.",
  },
  BUTTON_CONTINUE_TO_ANAMNESIS: {
    de: "Mit der Anamnese fortfahren",
    en: "Continue to Anamnesis",
    tr: "Anamneze Devam Et",
    cs: "Pokračovat k anamnéze",
    ru: "Перейти к анамнезу",
    hr: "Nastavi na anamnezu",
    es: "Continuar a la anamnesis",
    fr: "Continuer vers l'anamnèse",
    it: "Continua con l'anamnesi",
    sq: "Vazhdo te anamneza",
  },
  BUTTON_COMPLETE: {
    de: "Abschließen",
    en: "Complete",
    tr: "Tamamla",
    cs: "Dokončit",
    ru: "Завершить",
    hr: "Dovršiti",
    es: "Completar",
    fr: "Terminer",
    it: "Completa",
    sq: "Përfundo",
  },
  SUCCESS_SCREEN_END_TITLE: {
    de: "Vielen Dank für Ihre Zeit!",
    en: "Thank you for your time!",
    tr: "Zamanınız için teşekkürler!",
    cs: "Děkujeme za váš čas!",
    ru: "Спасибо за ваше время!",
    hr: "Hvala vam na vašem vremenu!",
    es: "¡Gracias por su tiempo!",
    fr: "Merci pour votre temps !",
    it: "Grazie per il tuo tempo!",
    sq: "Faleminderit për kohën tuaj!",
  },
  SUCCESS_SCREEN_END_DESCRIPTION: {
    de: "Ihre Daten wurden erfolgreich übermittelt. Vielen Dank - sie helfen uns, Sie bestmöglich zu betreuen.",
    en: "Your data has been successfully submitted. Thank you - it helps us to provide you with the best possible care.",
    tr: "Verileriniz başarıyla gönderildi. Teşekkürler - bu, size mümkün olan en iyi bakımı sağlamamıza yardımcı olur.",
    cs: "Vaše data byla úspěšně odeslána. Děkujeme - pomáhá nám to poskytnout vám co nejlepší péči.",
    ru: "Ваши данные были успешно отправлены. Спасибо - это помогает нам обеспечить вам наилучший уход.",
    hr: "Vaši su podaci uspješno poslani. Hvala vam - to nam pomaže da vam pružimo najbolju moguću skrb.",
    es: "Sus datos han sido enviados con éxito. Gracias, esto nos ayuda a brindarle la mejor atención posible.",
    fr: "Vos données ont été soumises avec succès. Merci - cela nous aide à vous fournir les meilleurs soins possibles.",
    it: "I tuoi dati sono stati inviati con successo. Grazie - ci aiuta a fornirti la migliore assistenza possibile.",
    sq: "Të dhënat tuaja janë dërguar me sukses. Faleminderit - na ndihmon të ofrojmë kujdesin më të mirë të mundshëm për ju.",
  },
  SUCCESS_WINDOW_CLOSE_INFO_TEXT: {
    de: "Sie können dieses Fenster jetzt sicher schließen.",
    en: "You can now safely close this window.",
    tr: "Artık bu pencereyi güvenle kapatabilirsiniz.",
    cs: "Nyní můžete toto okno bezpečně zavřít.",
    ru: "Теперь вы можете безопасно закрыть это окно.",
    hr: "Sada možete sigurno zatvoriti ovaj prozor.",
    es: "Ahora puede cerrar esta ventana de forma segura.",
    fr: "Vous pouvez maintenant fermer cette fenêtre en toute sécurité.",
    it: "Ora puoi chiudere questa finestra in sicurezza.",
    sq: "Tani mund ta mbyllni këtë dritare në mënyrë të sigurt.",
  },
  PERSONAL_DATA_LABEL: {
    de: "Persönliche Daten eingeben",
    en: "Enter Personal Data",
    tr: "Kişisel Verileri Girin",
    cs: "Zadejte osobní údaje",
    ru: "Введите личные данные",
    hr: "Unesite osobne podatke",
    es: "Ingrese datos personales",
    fr: "Entrez les données personnelles",
    it: "Inserisci dati personali",
    sq: "Shkruani të dhënat personale",
  },
  CHANGE_THERAPIST_DURING_TREATMENT_LABEL: {
    de: "Wechselnde Therapeuten",
    en: "Changing Therapists",
    tr: "Değişen Terapistler",
    cs: "Střídání terapeutů",
    ru: "Смена терапевтов",
    hr: "Promjena terapeuta",
    es: "Cambio de terapeutas",
    fr: "Changement de thérapeutes",
    it: "Cambio terapisti",
    sq: "Ndryshimi i terapistëve",
  },
  CHANGE_THERAPIST_DURING_TREATMENT_DESCRIPTION: {
    de: "Eine Behandlung durch mehrere Therapeuten ist für mich in Ordnung.",
    en: "I am okay with being treated by multiple therapists.",
    tr: "Birden fazla terapist tarafından tedavi olmam benim için uygun.",
    cs: "Nevadí mi, když mě bude léčit více terapeutů.",
    ru: "Я не против лечения у нескольких терапевтов.",
    hr: "U redu je da me liječi više terapeuta.",
    es: "Estoy de acuerdo con ser tratado por múltiples terapeutas.",
    fr: "Je suis d'accord pour être traité par plusieurs thérapeutes.",
    it: "Accetto di essere trattato da più terapisti.",
    sq: "Jam dakord të trajtohem nga terapistë të veel.",
  },
  ONLY_FEMALE_THERAPIST_LABEL: {
    de: "Nur weibliche Therapeuten",
    en: "Only Female Therapists",
    tr: "Sadece kadın terapistler",
    cs: "Pouze terapeutky",
    ru: "Только женщины-терапевты",
    hr: "Samo ženski terapeuti",
    es: "Solo terapeutas mujeres",
    fr: "Seulement des thérapeutes femmes",
    it: "Solo terapiste donne",
    sq: "Vetëm terapiste femra",
  },
  ONLY_MALE_THERAPIST_LABEL: {
    de: "Nur männliche Therapeuten",
    en: "Only Male Therapists",
    tr: "Sadece erkek terapistler",
    cs: "Pouze terapeuti muži",
    ru: "Только мужчины-терапевты",
    hr: "Samo muški terapeuti",
    es: "Solo terapeutas hombres",
    fr: "Seulement des thérapeutes hommes",
    it: "Solo terapisti uomini",
    sq: "Vetëm terapistë meshkuj",
  },
  HOUSE_VISIT_LABEL: {
    de: "Hausbesuch",
    en: "House Visit",
    tr: "Ev ziyareti",
    cs: "Domácí návštěva",
    ru: "Визит на дом",
    hr: "Kućni posjet",
    es: "Visita a domicilio",
    fr: "Visite à domicile",
    it: "Visita a domicilio",
    sq: "Vizitë në shtëpi",
  },
  HOUSE_VISIT_DESCRIPTION: {
    de: "Der Therapeut soll zu mir nach Hause kommen.",
    en: "The therapist should come to my home.",
    tr: "Terapistin evime gelmesini istiyorum.",
    cs: "Terapeut by měl přijít ke mně domů.",
    ru: "Терапевт должен прийти ко мне домой.",
    hr: "Terapeut bi trebao doći k meni doma.",
    es: "El terapeuta debe venir a mi casa.",
    fr: "Le thérapeute doit venir chez moi.",
    it: "Il terapista deve venire a casa mia.",
    sq: "Terapisti duhet të vijë në shtëpinë time.",
  },
  EXTENDED_TIME_LABEL: {
    de: "Behandlungszeit um 10 min verlängern",
    en: "Extend treatment time by 10 min",
    tr: "Tedavi süresini 10 dk uzat",
    cs: "Prodloužit dobu léčby o 10 min",
    ru: "Продлить время лечения на 10 мин",
    hr: "Produžite trajanje tretmana za 10 min",
    es: "Extender el tiempo de tratamiento en 10 min",
    fr: "Prolonger la durée du traitement de 10 min",
    it: "Prolungare la durata del trattamento di 10 min",
    sq: "Zgjat kohën e trajtimit me 10 min",
  },
  APPOINTMENT_PREFERENCES_SCREEN_TITLE: {
    de: "Details zu Ihrem Termin",
    en: "Details about your appointment",
    tr: "Randevunuzla ilgili detaylar",
    cs: "Podrobnosti o vaší schůzce",
    ru: "Детали вашей встречи",
    hr: "Detalji o vašem terminu",
    es: "Detalles sobre su cita",
    fr: "Détails sur votre rendez-vous",
    it: "Dettagli sul tuo appuntamento",
    sq: "Detaje rreth takimit tuaj",
  },
  APPOINTMENT_PREFERENCES_SCREEN_DESCRIPTION: {
    de: "Hier können Sie zusätzliche Wünsche für den Termin hinzufügen. Je flexibler Sie sind, desto schneller können wir Termine anbieten.",
    en: "Here you can add additional requests for the appointment. The more flexible you are, the faster we can offer appointments.",
    tr: "Buradan randevu için ek isteklerinizi ekleyebilirsiniz. Ne kadar esnek olursanız, o kadar hızlı randevu sunabiliriz.",
    cs: "Zde můžete přidat další požadavky na schůzku. Čím flexibilnější budete, tím rychleji můžeme nabídnout termíny.",
    ru: "Здесь вы можете добавить дополнительные пожелания к приему. Чем вы гибче, тем быстрее мы сможем предложить время.",
    hr: "Ovdje možete dodati dodatne zahtjeve za termin. Što ste fleksibilniji, brže možemo ponuditi termine.",
    es: "Aquí puede agregar solicitudes adicionales para la cita. Cuanto más flexible sea, más rápido podremos ofrecer citas.",
    fr: "Ici, vous pouvez ajouter des demandes supplémentaires pour le rendez-vous. Plus vous êtes flexible, plus vite nous pouvons proposer des rendez-vous.",
    it: "Qui puoi aggiungere ulteriori richieste per l'appuntamento. Più sei flessibile, più velocemente possiamo offrire appuntamenti.",
    sq: "Këtu mund të shtoni kërkesa shtesë për takimin. Sa më fleksibël të jeni, aq më shpejt mund të ofrojmë takime.",
  },
  RETURN_TO_WEBSITE: {
    de: "Zurück zur Webseite",
    en: "Back to website",
    tr: "Web sitesine dön",
    cs: "Zpět na web",
    ru: "Вернуться на сайт",
    hr: "Natrag na web stranicu",
    es: "Volver al sitio web",
    fr: "Retour au site web",
    it: "Torna al sito web",
    sq: "Kthehu në faqen e internetit",
  },
  CLOSE_WINDOW_TEXT: {
    de: "Sie können jetzt diese Seite schließen.",
    en: "You can now close this page.",
    tr: "Artık bu sayfayı kapatabilirsiniz.",
    cs: "Nyní můžete tuto stránku zavřít.",
    ru: "Теперь вы можете закрыть эту страницу.",
    hr: "Sada možete zatvoriti ovu stranicu.",
    es: "Ahora puede cerrar esta página.",
    fr: "Vous pouvez maintenant fermer cette page.",
    it: "Ora puoi chiudere questa pagina.",
    sq: "Tani mund ta mbyllni këtë faqe.",
  },
  USAGE_CONDITIONS_TITLE: {
    de: "Nutzungsbedingungen",
    en: "Terms of Use",
    tr: "Kullanım Şartları",
    cs: "Podmínky použití",
    ru: "Условия использования",
    hr: "Uvjeti korištenja",
    es: "Términos de uso",
    fr: "Conditions d'utilisation",
    it: "Termini di utilizzo",
    sq: "Kushtet e përdorimit",
  },
  FOOTER_DATA_PRIVACY_POLICY: {
    de: "Im folgenden Prozess werden personenbezogene Daten verarbeitet. Weitere Informationen finden Sie in den Datenschutzerklärungen der <physiofitUrl>Physiofit Digital GmbH<physiofitUrl> und Ihrer <practiceUrl>Praxis<practiceUrl>.",
    en: "Your Personal data will be processed in the following process. For more information, please refer to the privacy policies of <physiofitUrl>Physiofit Digital GmbH<physiofitUrl> and your <practiceUrl>practice<practiceUrl>.",
    tr: "Kişisel verileriniz aşağıdaki süreçte işlenecektir. Daha fazla bilgi için lütfen <physiofitUrl>Physiofit Digital GmbH<physiofitUrl> ve <practiceUrl>kliniğinizin<practiceUrl> gizlilik politikalarına bakın.",
    cs: "Vaše osobní údaje budou zpracovány v následujícím procesu. Pro více informací se prosím podívejte na zásady ochrany osobních údajů <physiofitUrl>Physiofit Digital GmbH<physiofitUrl> a vaší <practiceUrl>praxe<practiceUrl>.",
    ru: "Ваши личные данные будут обработаны в следующем процессе. Для получения дополнительной информации, пожалуйста, обратитесь к политикам конфиденциальности <physiofitUrl>Physiofit Digital GmbH<physiofitUrl> и вашей <practiceUrl>клиники<practiceUrl>.",
    hr: "Vaši osobni podaci bit će obrađeni u sljedećem procesu. Za više informacija, molimo pogledajte pravila privatnosti <physiofitUrl>Physiofit Digital GmbH<physiofitUrl> i vaše <practiceUrl>ordinacije<practiceUrl>.",
    es: "Sus datos personales serán procesados en el siguiente proceso. Para obtener más información, consulte las políticas de privacidad de <physiofitUrl>Physiofit Digital GmbH<physiofitUrl> y su <practiceUrl>práctica<practiceUrl>.",
    fr: "Vos données personnelles seront traitées dans le processus suivant. Pour plus d'informations, veuillez consulter les politiques de confidentialité de <physiofitUrl>Physiofit Digital GmbH<physiofitUrl> et de votre <practiceUrl>cabinet<practiceUrl>.",
    it: "I tuoi dati personali saranno trattati nel processo seguente. Per maggiori informazioni, consulta le politiche sulla privacy di <physiofitUrl>Physiofit Digital GmbH<physiofitUrl> e del tuo <practiceUrl>studio<practiceUrl>.",
    sq: "Të dhënat tuaja personale do të përpunohen në procesin e mëposhtëm. Për më shumë informacion, ju lutem referojuni politikave të privatësisë së <physiofitUrl>Physiofit Digital GmbH<physiofitUrl> dhe <practiceUrl>klinikës suaj<practiceUrl>.",
  },
  USAGE_CONDITIONS_TEXT: {
    de: "Ich akzeptiere die Nutzungsbedingungen der Physiofit Digital GmbH und habe die <privacyPolicyUrl>Datenschutzerklärung<privacyPolicyUrl> zur Kenntnis genommen.",
    en: "I accept the terms of use of Physiofit Digital GmbH and have taken note of the <privacyPolicyUrl>privacy policy<privacyPolicyUrl>.",
    tr: "Physiofit Digital GmbH'nin kullanım şartlarını kabul ediyorum ve <privacyPolicyUrl>gizlilik politikasını<privacyPolicyUrl> dikkate aldım.",
    cs: "Souhlasím s podmínkami použití společnosti Physiofit Digital GmbH a beru na vědomí <privacyPolicyUrl>zásady ochrany osobních údajů<privacyPolicyUrl>.",
    ru: "Я принимаю условия использования Physiofit Digital GmbH и ознакомился с <privacyPolicyUrl>политикой конфиденциальности<privacyPolicyUrl>.",
    hr: "Prihvaćam uvjete korištenja tvrtke Physiofit Digital GmbH i upoznat sam s <privacyPolicyUrl>politikom privatnosti<privacyPolicyUrl>.",
    es: "Acepto los términos de uso de Physiofit Digital GmbH y he tomado nota de la <privacyPolicyUrl>política de privacidad<privacyPolicyUrl>.",
    fr: "J'accepte les conditions d'utilisation de Physiofit Digital GmbH et j'ai pris note de la <privacyPolicyUrl>politique de confidentialité<privacyPolicyUrl>.",
    it: "Accetto i termini di utilizzo di Physiofit Digital GmbH e ho preso nota della <privacyPolicyUrl>politica sulla privacy<privacyPolicyUrl>.",
    sq: "Unë pranoj kushtet e përdorimit të Physiofit Digital GmbH dhe kam marrë parasysh <privacyPolicyUrl>politikën e privatësisë<privacyPolicyUrl>.",
  },
  USAGE_CONDITIONS_TEXT_NO_PRAXIS_LINK: {
    de: "Physiofit ermöglicht Ihnen, auf die Dokumente Ihrer Praxis zuzugreifen. Hierfür gelten die Datenschutzerklärung der <physiofitUrl>Physiofit Digital GmbH<physiofitUrl>. Sie bestätigen, dass Sie diese gelesen haben, und jeweils einverstanden sind.",
    en: "Physiofit allows you to access your practice's documents. The privacy policy of <physiofitUrl>Physiofit Digital GmbH<physiofitUrl> applies. You confirm that you have read and agree to it.",
    tr: "Physiofit, kliniğinizin belgelerine erişmenizi sağlar. Bunun için <physiofitUrl>Physiofit Digital GmbH<physiofitUrl> gizlilik politikası geçerlidir. Bunu okuduğunuzu ve kabul ettiğinizi onaylıyorsunuz.",
    cs: "Physiofit vám umožňuje přístup k dokumentům vaší praxe. Platí zásady ochrany osobních údajů <physiofitUrl>Physiofit Digital GmbH<physiofitUrl>. Potvrzujete, že jste si je přečetli a souhlasíte s nimi.",
    ru: "Physiofit позволяет вам получить доступ к документам вашей клиники. Применяется политика конфиденциальности <physiofitUrl>Physiofit Digital GmbH<physiofitUrl>. Вы подтверждаете, что прочитали и согласны с ней.",
    hr: "Physiofit vam omogućuje pristup dokumentima vaše ordinacije. Primjenjuju se pravila o privatnosti <physiofitUrl>Physiofit Digital GmbH<physiofitUrl>. Potvrđujete da ste ih pročitali i da se slažete s njima.",
    es: "Physiofit le permite acceder a los documentos de su práctica. Se aplica la política de privacidad de <physiofitUrl>Physiofit Digital GmbH<physiofitUrl>. Confirma que la ha leído y está de acuerdo con ella.",
    fr: "Physiofit vous permet d'accéder aux documents de votre cabinet. La politique de confidentialité de <physiofitUrl>Physiofit Digital GmbH<physiofitUrl> s'applique. Vous confirmez l'avoir lu et accepté.",
    it: "Physiofit ti consente di accedere ai documenti del tuo studio. Si applica l'informativa sulla privacy di <physiofitUrl>Physiofit Digital GmbH<physiofitUrl>. Confermi di averla letta e di accettarla.",
    sq: "Physiofit ju lejon të qaseni në dokumentet e klinikës suaj. Zbatohet politika e privatësisë së <physiofitUrl>Physiofit Digital GmbH<physiofitUrl>. Ju konfirmoni se e keni lexuar dhe pajtoheni me të.",
  },

  UPLOADING_DOCUMENTS: {
    de: "Dokumente werden hochgeladen...",
    en: "Uploading documents...",
    tr: "Belgeler yükleniyor...",
    cs: "Nahrávání dokumentů...",
    ru: "Загрузка документов...",
    hr: "Učitavanje dokumenata...",
    es: "Subiendo documentos...",
    fr: "Téléchargement des documents...",
    it: "Caricamento documenti...",
    sq: "Duke ngarkuar dokumentet...",
  },
  DOCUMENTS_UPLOADED: {
    de: "Dokumente hochgeladen",
    en: "Documents uploaded",
    tr: "Belgeler yüklendi",
    cs: "Dokumenty nahrány",
    ru: "Документы загружены",
    hr: "Dokumenti učitani",
    es: "Documentos subidos",
    fr: "Documents téléchargés",
    it: "Documenti caricati",
    sq: "Dokumentet u ngarkuan",
  },
  CAMERA_UPLOAD_IMAGE: {
    de: "Bild hochladen",
    en: "Upload image",
    tr: "Resim yükle",
    cs: "Nahrát obrázek",
    ru: "Загрузить изображение",
    hr: "Učitaj sliku",
    es: "Subir imagen",
    fr: "Télécharger l'image",
    it: "Carica immagine",
    sq: "Ngarko imazhin",
  },
  CAMERA_UPLOAD_FROM_DEVICE: {
    de: "Vom Gerät auswählen",
    en: "Choose from device",
    tr: "Cihazdan seç",
    cs: "Vybrat ze zařízení",
    ru: "Выбрать с устройства",
    hr: "Odaberi s uređaja",
    es: "Elegir del dispositivo",
    fr: "Choisir depuis l'appareil",
    it: "Scegli dal dispositivo",
    sq: "Zgjidh nga pajisja",
  },
  CAMERA_INVALID_FILE_TYPE: {
    de: "Bitte wählen Sie ein JPG- oder PNG-Bild aus",
    en: "Please select a JPG or PNG image",
    tr: "Lütfen bir JPG veya PNG resmi seçin",
    cs: "Vyberte prosím obrázek JPG nebo PNG",
    ru: "Пожалуйста, выберите изображение JPG или PNG",
    hr: "Molimo odaberite JPG ili PNG sliku",
    es: "Por favor seleccione una imagen JPG o PNG",
    fr: "Veuillez sélectionner une image JPG ou PNG",
    it: "Seleziona un'immagine JPG o PNG",
    sq: "Ju lutem zgjidhni një imazh JPG ose PNG",
  },
  OR: {
    de: "oder",
    en: "or",
    tr: "veya",
    cs: "nebo",
    ru: "или",
    hr: "ili",
    es: "o",
    fr: "ou",
    it: "o",
    sq: "ose",
  },
  APPOINTMENT_RECIPE_SELECT_FROM_GALLERY: {
    de: "Rezept aus Galerie wählen",
    en: "Select Prescription from Gallery",
    tr: "Galeriden Reçete Seç",
    cs: "Vybrat recept z galerie",
    ru: "Выбрать рецепт из галереи",
    hr: "Odaberi recept iz galerije",
    es: "Seleccionar receta de la galería",
    fr: "Sélectionner l'ordonnance dans la galerie",
    it: "Seleziona ricetta dalla galleria",
    sq: "Zgjidh recetën nga galeria",
  },
} as const;
